{
  "· {0} см": "· {0} sm",
  "· версия": "· versiya",
  "· доступно": "· mavjud",
  "· заказ": "· buyurtma",
  "· изменен": "· o‘zgartirilgan",
  "· ожидается": "· kutilgan",
  "· попыток": "urinishlar",
  "· правило доработки:": "qayta ishlash qoidasi:",
  "· резерв": "· zaxira",
  "· согласование": "· tasdiqlash",
  "· ячейка": "· katak",
  "{0} · срок {1}": "{0} · muddatli {1}",
  "{0} МБ": "{0} MB",
  "{0} мин": "{0} min",
  "{0} с": "{0} bilan",
  "{0}: план {1}, факт {2}": "{0}: {1} rejasi, {2} fakt",
  "{item.bundle.code} · {item.bundle.size.name} · {item.quantity} шт.": "{item.bundle.code} · {item.bundle.size.name} · {item.quantity} dona.",
  "{key}: значение должно быть не меньше {minimum}": "{key}: qiymat kamida {minimum} boʻlishi kerak",
  "{key}: ожидается число": "{key}: kutilayotgan raqam",
  "{labels.get(k, k)}: {'да' if v else 'нет'}": "{labels.get(k, k)}: {'да' if v else 'нет'}",
  "{line.balance.product_variant.code} · {line.balance.size.name} · {line.balance.batch.code} · {line.quantity} шт.": "{line.balance.product_variant.code} · {line.balance.size.name} · {line.balance.batch.code} · {line.quantity} dona.",
  "{mode}: {batch.rows_total} строк проверено, {batch.rows_imported} создано, {batch.rows_skipped} без изменений. Batch: {batch.id}": "{mode}: {batch.rows_total} qatorlar tekshirildi, {batch.rows_imported} yaratildi, {batch.rows_skipped} o‘zgarmadi. To‘plam: {batch.id}",
  "{operation.work_center.name} · {operation.standard_minutes} мин": "{operation.work_center.name} {operation.standard_minutes} min",
  "{row.code}: {row.quantity} шт. ожидают завершения.": "{row.code}: {row.quantity} dona. yakunlanishini kutmoqda.",
  "{row.code}: к утверждению {row.total_amount} {row.currency}.": "{row.code}: tasdiqlash uchun {row.total_amount} {row.currency}.",
  "{row.code}: срок {row.due_date:%d.%m.%Y}.": "{row.code}: {row.due_date:%d.%m.%Y} atamasi.",
  "{row.material.code}: не хватает {row.shortage_quantity} {row.material.unit.symbol}.": "{row.material.code}: {row.shortage_quantity} {row.material.unit.symbol} yo‘q.",
  "{row.product_variant.code}: доступно {row.available_quantity} шт.": "{row.product_variant.code}: mavjud {row.available_quantity} dona.",
  "2FA включена. Передайте данные пользователю по защищенному каналу.": "2FA yoqilgan. Xavfsiz kanal orqali foydalanuvchiga ma'lumotlarni uzatish.",
  "2FA отключена; все активные сессии пользователя отозваны.": "2FA o‘chirilgan; barcha faol foydalanuvchi seanslari bekor qilinadi.",
  "30% предоплата, остаток после приемки": "30% oldindan to‘lov, qabul qilingandan keyin qoldiq",
  "403 · Ограничение доступа": "403 Kirish cheklovi",
  "404 · Маршрут не найден": "404 Marshrut topilmadi",
  "6 цифр или резервный код": "6 ta raqam yoki zaxira kodi",
  "65% полиэстер / 35% хлопок, ширина 150 см": "65% polyester / 35% paxta, kengligi 150 sm",
  "Автоматически сформировано из дефицита заказа {order.code}": "{order.code} buyurtma etishmasligidan avtomatik ravishda yaratilgan",
  "Автор": "Muallif",
  "Адаптер внешнего канала не настроен. Событие сохранено для этапа 7.": "Tashqi kanal adapteri sozlanmagan. Hodisa 7-bosqich uchun saqlanadi.",
  "Администратор": "Administrator",
  "Администрирование / параметры": "Boshqaruv/Options",
  "Адрес": "Manzil",
  "Адрес отгрузки": "Yetkazib berish manzili",
  "Адрес: {shipment.shipping_address}": "Manzil: {shipment.shipping_address}",
  "Адресное хранение": "Manzil saqlash",
  "Азиз Норматов": "Aziz Normatov",
  "Акмал": "Akmal",
  "Активен": "Faol",
  "Активированную или использованную версию BOM изменять нельзя.": "BOM ning faollashtirilgan yoki ishlatilgan versiyasini o‘zgartirib bo‘lmaydi.",
  "Активированную или использованную версию BOM удалить нельзя.": "BOM ning faollashtirilgan yoki ishlatilgan versiyasini o‘chirib bo‘lmaydi.",
  "Активированный или использованный маршрут изменять нельзя.": "Faollashtirilgan yoki foydalanilgan marshrutni o‘zgartirib bo‘lmaydi.",
  "Активированный или использованный маршрут удалить нельзя.": "Faollashtirilgan yoki ishlatilgan marshrutni o‘chirib bo‘lmaydi.",
  "Активировать": "Faollashtirish",
  "Активировать можно только черновик версии.": "Faqat qoralama versiyasini faollashtirish mumkin.",
  "Активировать можно только черновик маршрута.": "Siz faqat qoralama marshrutni faollashtirishingiz mumkin.",
  "Активна": "Faol",
  "Активно": "Faol",
  "Активные сотрудники": "Faol xodimlar",
  "Активный пользователь не найден.": "Hech qanday faol foydalanuvchi topilmadi.",
  "активных назначений": "faol tayinlovlar",
  "активных партий / рулонов": "faol partiyalar/rulonlar",
  "Алимова": "Alimova",
  "Аналог": "Analog",
  "Аналог / действие": "Analog / harakat",
  "Аналог должен использовать ту же единицу измерения.": "Analog bir xil o‘lchov birligini ishlatishi kerak.",
  "Аналоги": "Analoglar",
  "Архив": "Arxiv",
  "Аудит и системные задания": "Audit va tizim vazifalari",
  "Аудитор / просмотр": "Auditor/ko‘rish",
  "Базовая промышленная норма": "Asosiy sanoat normasi",
  "Базовый маршрут этапа 3": "3-bosqich asosiy marshrut",
  "Бахтиёр": "Baxtiyor",
  "Без детализации": "Tafsilotlar yo‘q",
  "Без договора": "Shartnomasiz",
  "Без заказа": "Buyurtma yo‘q",
  "Без заявки": "So‘rovsiz",
  "без изменений": "o‘zgarishlar yo‘q",
  "Без комментария": "Izoh yo‘q",
  "без окончания": "tugamasdan",
  "Безопасность / RBAC": "Xavfsizlik / RBAC",
  "Безопасный QR": "Xavfsiz QR",
  "Блокировка": "Qulflash",
  "Больничный": "Kasallik ta'tillari",
  "Брак": "Brak",
  "Брак кроя, комплектов": "Bichish va to‘plam braklari",
  "Бренд": "Brend",
  "Бригада": "Brigada",
  "Бригада №1": "1-sonli brigada",
  "Брюки": "Shimlar",
  "Брюки полевые": "Dala shimlari",
  "Брюки полевые · оливковые": "Dala shimlari zaytun",
  "Будут созданы задания на все операции действующего маршрута.": "Joriy marshrutning barcha operatsiyalari uchun ish o‘rinlari yaratiladi.",
  "Быстрый факт · {0}": "Tez fakt · {0}",
  "В ведомости нет начислений.": "Qaydnomada hisob-kitoblar yo‘q.",
  "В выбранной ячейке нет остатка этого лота.": "Tanlangan katakda bu lotning qoldig‘i yo‘q.",
  "в графике": "grafikada",
  "В маршруте нет операций пошива.": "Marshrutda tikuv operatsiyalari mavjud emas.",
  "В отпуске": "Ta'tilda",
  "В очереди": "Navbatda",
  "В приход включаются только полностью упакованные короба с совпадающим количеством.": "Kvitansiyaga faqat bir xil miqdordagi to‘liq qadoqlangan qutilar kiritilgan.",
  "В работе": "Jarayonda",
  "В резервах выбранного лота доступно только {available}.": "Tanlangan lotning zahiralarida faqat {available} mavjud.",
  "в резерве": "zaxirada",
  "В резерве": "Zaxirada",
  "В ячейку": "Katakga",
  "Важность": "Muhimligi",
  "Валюта": "Valyuta",
  "Вариант": "Variant",
  "Вариант изделия": "Mahsulot varianti",
  "Вариант относится к другой организации.": "Variant boshqa tashkilotga tegishli.",
  "Варианты": "Variantlar",
  "Ваша роль не содержит разрешение для этой операции. Обратитесь к администратору.": "Sizning rolingiz ushbu operatsiya uchun ruxsatni o‘z ichiga olmaydi. Administratoringizga murojaat qiling.",
  "Введите действующий код 2FA или резервный код.": "Joriy 2FA kodini yoki zaxira kodini kiriting.",
  "Введите правильный адрес электронной почты.": "To‘g‘ri elektron pochta manzilini kiriting.",
  "Ввести факт": "Fakt kiriting",
  "Ведомостей пока нет": "Hozircha hech qanday qaydnomalar yo‘q",
  "Ведомости": "Qaydnomalar",
  "Ведомость": "Qaydnoma",
  "Ведомость еще не рассчитана": "Qaydnoma hali hisoblab chiqilmagan",
  "Ведомственная маркировка": "Bo‘lim belgilari",
  "Вернуться к обзору": "Ko‘rib chiqishga qaytish",
  "Версии и состав": "Versiyalar va kompozitsiyalar",
  "Версионируемые значения этапа 1 без физического удаления использованных записей.": "Ishlatilgan yozuvlarni jismonan o‘chirmasdan versiyali 1-bosqich qiymatlari.",
  "Версия карточки": "Karta versiyasi",
  "Вес брутто, кг": "Brüt vazn, kg",
  "Весь объем комплекта уже проверен.": "To‘plamning butun hajmi allaqachon tekshirilgan.",
  "видна до": "birlamchi faktgacha",
  "Включает TOTP 2FA и выдает одноразовый комплект резервных кодов.": "TOTP 2FA ni yoqadi va bir martalik zaxira kodlari to‘plamini chiqaradi.",
  "Вложения": "Qo‘shimchalar",
  "Внешний CSV": "Tashqi CSV",
  "возврат": "qaytarib berish",
  "Возврат": "Qaytish",
  "Возврат материала": "Materialni qaytarish",
  "Возврат остатка после раскроя {task.code}": "{task.code} kesilganidan keyin qoldiqning qaytarilishi",
  "Возвращено": "Qaytgan",
  "Войти в систему": "Kirish",
  "воспроизводимо": "takrorlanishi mumkin",
  "Восстановленный резерв превышает физический остаток.": "Qayta tiklangan zaxira jismoniy balansdan oshib ketadi.",
  "Временный пароль": "Vaqtinchalik parol",
  "Время ухода должно быть позже времени прихода.": "Ketish vaqti kelish vaqtidan kechroq bo‘lishi kerak.",
  "Все комплекты должны относиться к партии упаковки.": "Barcha to‘plamlar paketdan bo‘lishi kerak.",
  "Все размеры": "Barcha o‘lchamlar",
  "Все сессии завершены": "Barcha seanslar yakunlandi",
  "Все статусы": "Barcha holatlar",
  "Все уведомления": "Barcha bildirishnomalar",
  "Всего записей": "Jami yozuvlar",
  "Всесезонная": "Butun mavsum",
  "Втачивание рукавов": "Yenglarda o‘rnatish",
  "Вход в рабочее пространство": "Ish maydoniga kirish",
  "Вход временно заблокирован. Повторите позже.": "Kirish vaqtinchalik bloklangan. Keyinroq qayta urinib ko‘ring.",
  "Входим…": "Kiramiz...",
  "Входы, изменения прав и бизнес-действия с контекстом запроса.": "So‘rov konteksti bilan kiritilgan ma'lumotlar, huquqlarni o‘zgartirish va biznes harakatlari.",
  "Входящая очередь": "Kiruvchi navbat",
  "Выберите": "Tanlang",
  "Выберите вариант": "Variantni tanlang",
  "Выберите действующий маршрут для варианта строки заказа.": "Buyurtma liniyasi opsiyasi uchun yaroqli marshrutni tanlang.",
  "Выберите заказ": "Buyurtmani tanlang",
  "Выберите заказ и складскую ячейку.": "Buyurtma va saqlash qutisini tanlang.",
  "Выберите клиента": "Mijozni tanlang",
  "Выберите операцию": "Operatsiyani tanlang",
  "Выберите фотографию дефекта.": "Kamchilikning fotosuratini tanlang.",
  "Выберите хотя бы одно право.": "Kamida bitta o‘ngni tanlang.",
  "Выберите ячейку и партию.": "Katak va to‘plamni tanlang.",
  "Выберите ячейку склада готовой продукции.": "Tayyor mahsulot omborini tanlang.",
  "Выберите CSV-файл.": "CSV faylini tanlang.",
  "Выдано": "Chiqarilgan",
  "Выдано {task.issued_quantity}; расход + возврат + отход должны дать ту же сумму.": "{task.issued_quantity} tomonidan chiqarilgan; xarajat + qaytish + chiqindilar bir xil miqdorda berishi kerak.",
  "Выдать материал": "Chiqarish materiali",
  "Выдача": "Muammo",
  "Выдача под заказ": "Buyurtma bo‘yicha yetkazib berish",
  "Выдача резерва": "Zaxirani chiqarish",
  "Выдача, возврат и перемещение": "Chiqarish, qaytarish va uzatish",
  "Выйти": "Chiqish",
  "Выполнена": "Bajarildi",
  "Выполнено": "Bajarildi",
  "Выполняется": "Davom etilmoqda",
  "Выпуск": "Muammo",
  "Выпуск комплектов превышает план производственной партии.": "To‘plamlarni ishlab chiqarish ishlab chiqarish partiyasi rejasidan oshib ketadi.",
  "Выпуск сегодня": "Bugun chiqaring",
  "Выпустить комплекты": "Chiqarish to‘plamlari",
  "Выпущено": "Chiqarilgan",
  "Выработка и сдельная оплата": "Ishlab chiqarish va qismlarga to‘lov",
  "Высокий": "Yuqori",
  "Высший": "Oliy",
  "Вышестоящее подразделение": "Oliy bo‘lim",
  "Главная площадка": "Asosiy sayt",
  "головной убор": "bosh kiyim",
  "Головной убор": "Bosh kiyim",
  "Город, улица, объект": "Shahar, ko‘cha, ob'ekt",
  "Готов": "Tayyor",
  "Готовая продукция": "Tayyor mahsulot",
  "Готовая продукция · зона отгрузки": "Tayyor mahsulotlarni yetkazib berish hududi",
  "Готовая продукция / комплектность": "Tayyor mahsulotlar/to‘liqlik",
  "Готовая продукция еще не поступала": "Tayyor mahsulotlar hali kelmagan",
  "готовая продукция за вычетом резерва": "tayyor mahsulotlar kamroq zaxira",
  "Готовим форму заказа": "Buyurtma shaklini tayyorlash",
  "Готовность к отгрузке": "Yetkazib berishga tayyor",
  "готово": "tayyor",
  "Готово": "Bajarildi",
  "Готово к отгрузке": "Yetkazib berishga tayyor",
  "График": "Jadval",
  "ГУП «УВС»": "\"UVS\" davlat unitar korxonasi",
  "да": "ha",
  "Да": "Ha",
  "Данных пока нет": "Hozircha ma’lumot yo‘q",
  "Дата": "Sana",
  "Дата / документ": "Sana/hujjat",
  "Дата выдачи": "Chiqarilgan sana",
  "Дата готовности": "Tayyor bo‘lish sanasi",
  "Дата готовности не может быть в прошлом.": "Tayyor sana o‘tmishda bo‘lishi mumkin emas.",
  "Дата и время": "Sana va vaqt",
  "Дата начала": "Boshlanish sanasi",
  "Дата окончания": "Tugash sanasi",
  "Дата окончания не может быть раньше даты начала.": "Tugash sanasi boshlanish sanasidan oldinroq bo‘lishi mumkin emas.",
  "Дата операции": "Operatsiya sanasi",
  "Дата приема": "Qabul qilingan sana",
  "Дата увольнения не может быть раньше даты приема.": "Ishdan bo‘shatish sanasi ishga qabul qilingan kundan oldin bo‘lishi mumkin emas.",
  "Движение": "Harakat",
  "Движения готовой продукции не удаляются.": "Tayyor mahsulotlar harakati o‘chirilmaydi.",
  "Движения ГП": "SOE harakatlari",
  "Движения ledger не удаляются.": "Daftar harakatlari o‘chirilmaydi.",
  "Деактивировать": "Faolsizlantirish",
  "Деактивировать запись? История и ссылки сохранятся.": "Kirish o‘chirilsinmi? Tarix va havolalar saqlanadi.",
  "Действие": "Harakat",
  "Действие фиксируется в журнале аудита. Укажите основание.": "Harakat audit jurnalida qayd etiladi. Iltimos, sababini ko‘rsating.",
  "Действует": "Yaroqli",
  "Действует до": "gacha amal qiladi",
  "Действует по": "ga muvofiq amal qiladi",
  "Действует с": "dan amal qiladi",
  "Действующая версия": "Joriy versiya",
  "Действующие смены": "Joriy siljishlar",
  "Делегатор не обладает одним из выбранных прав.": "Delegator tanlangan huquqlardan biriga ega emas.",
  "Делегирование не удаляется. Используйте отзыв.": "Delegatsiya o‘chirilmaydi. Fikr-mulohazalardan foydalaning.",
  "Демоданные этапов 1–2 готовы. Логин: admin / Leytenant2026!": "1-2 bosqich demo ma'lumotlari tayyor. Kirish: admin / Leytenant2026!",
  "Демоданные этапов 1–3 готовы. Логин: admin / Leytenant2026!": "1–3 bosqich demo maʼlumotlari tayyor. Kirish: admin / Leytenant2026!",
  "Демоданные этапов 1–4 готовы. Логин: admin / Leytenant2026!": "1–4 bosqich demo maʼlumotlari tayyor. Kirish: admin / Leytenant2026!",
  "Демоданные этапов 1–5 готовы. Логин: admin / Leytenant2026!": "1–5 bosqichlarning demo maʼlumotlari tayyor. Kirish: admin / Leytenant2026!",
  "Демоданные этапов 1–6 готовы. Логин: admin / Leytenant2026!": "1–6 bosqichlarning demo maʼlumotlari tayyor. Kirish: admin / Leytenant2026!",
  "Демонстрационный доступ": "Demo kirish",
  "Демонстрационный заказ производственного контура": "Ishlab chiqarish sxemasining demo tartibi",
  "Демонстрационный короб {index}/3": "{index}/3 ko‘rsatish qutisi",
  "Демонстрационный табель этапа 5": "5-bosqich demo hisobot kartasi",
  "Демонстрационный частичный выпуск": "Demo qisman chiqarish",
  "Дефект": "Kamchilik",
  "Дефект строчки устранен": "Tikuvdagi nuqson tuzatildi",
  "Дефект шва": "Tikuv nuqsoni",
  "Дефектов не зафиксировано": "Hech qanday nuqson qayd etilmagan",
  "Дефекты": "Nuqsonlar",
  "Дефекты за период": "Davr uchun kamchiliklar",
  "Дефекты завершенной проверки ОТК не изменяются.": "Tugallangan sifat nazorati tekshiruvining kamchiliklari o‘zgartirilmaydi.",
  "Дефекты и доработка": "Kamchiliklar va qayta ishlash",
  "Дефекты и фотоподтверждения": "Kamchiliklar va fotografik dalillar",
  "Дефицит": "Kamchilik",
  "Дефицит материала": "Materiallar etishmasligi",
  "Дефицит материалов": "Materiallar etishmasligi",
  "Дефицит превращается в согласованную заявку, затем — в контролируемый заказ поставщику.": "Kamchilik kelishilgan buyurtmaga, so‘ngra etkazib beruvchiga boshqariladigan buyurtmaga aylanadi.",
  "Дефицит уже включен в заявку {existing_line.request.code}.": "Kamomad allaqachon {existing_line.request.code} ilovasiga kiritilgan.",
  "Дилшод": "Dilshod",
  "Директор": "Direktor",
  "Диспетчерская": "Dispetcherlik",
  "Диспетчерская доска": "Dispetcherlik kengashi",
  "Длина настила, м": "Zamin uzunligi, m",
  "Для {item.bundle.code} доступно к упаковке только {available}. Непринятая продукция заблокирована.": "{item.bundle.code} uchun faqat {available} qadoqlash uchun mavjud. Qabul qilinmagan mahsulotlar bloklanadi.",
  "Для варианта {line.product_variant.code} нет действующей версии BOM.": "{line.product_variant.code} varianti uchun yaroqli BOM versiyasi mavjud emas.",
  "Для возврата укажите только ячейку назначения.": "Qaytish uchun faqat manzil katakchasini belgilang.",
  "Для выбранной партии материала нет активного резерва под заказ.": "Tanlangan material partiyasi uchun faol buyurtmalar to‘plami mavjud emas.",
  "Для выдачи/списания укажите только ячейку-источник.": "Chiqarish/hisobdan chiqarish uchun faqat manba katakchasini belgilang.",
  "Для миграции разрешены только CSV-файлы.": "Migratsiya uchun faqat CSV fayllarga ruxsat beriladi.",
  "Для партии {line.lot.internal_lot} под заказ зарезервировано только {available_reserved}.": "{line.lot.internal_lot} partiyasi uchun faqat {available_reserved} buyurtma uchun ajratilgan.",
  "Для перемещения нужны разные ячейки источника и назначения.": "Ko‘chirish turli manba va maqsadli kataklarni talab qiladi.",
  "Для привилегированной роли необходимо настроить 2FA у администратора.": "Imtiyozli rol uchun siz 2FA ni administrator sifatida sozlashingiz kerak.",
  "Для резерва доступно {balance.available_quantity}.": "{balance.available_quantity} zaxira uchun mavjud.",
  "Для списания обязательна причина.": "Hisobdan chiqarish uchun sabab bo‘lishi kerak.",
  "Для статуса {target} обязательны поля: {', '.join(missing)}.": "{target} holati uchun kerakli maydonlar: {', '.join(missing)}.",
  "Для строки заказа не рассчитана потребность.": "Buyurtma qatorida hisoblangan talab yo‘q.",
  "Для утверждения нужны дата готовности и минимум одна положительная позиция.": "Tasdiqlash uchun tugatish sanasi va kamida bitta ijobiy element talab qilinadi.",
  "Для этого раздела не назначено разрешение.": "Bu bo‘lim uchun ruxsat berilmagan.",
  "Дневная смена": "Kunduzgi smena",
  "Дневной выпуск относительно плана": "Rejaga nisbatan kunlik nashr",
  "Добавить": "Qo‘shish",
  "Добавить комментарий к заказу": "Buyurtmangizga sharh qo‘shing",
  "Добавить позицию": "Lavozim qo‘shing",
  "Добавить сотрудника": "Xodimni qo‘shing",
  "Добавить файл": "Fayl qo‘shish",
  "Добавьте минимум один материал в BOM.": "BOM ga kamida bitta material qo‘shing.",
  "Добавьте минимум одну операцию маршрута.": "Kamida bitta marshrut operatsiyasini qo‘shing.",
  "Добавьте минимум одну позицию.": "Kamida bitta element qo‘shing.",
  "Добавьте минимум одну строку инвентаризации.": "Kamida bitta inventar qatorini qo‘shing.",
  "Добавьте минимум одну строку приемки.": "Kamida bitta qabul chizig‘ini qo‘shing.",
  "Добавьте минимум одну строку.": "Kamida bitta qator qo‘shing.",
  "Добавьте строки готовой продукции и упаковки.": "Tayyor mahsulotlar va qadoqlash liniyalarini qo‘shing.",
  "Добавьте хотя бы один комплект.": "Kamida bitta to‘plam qo‘shing.",
  "Добрый день, {0}": "Xayrli kun, {0}",
  "Договор": "Shartnoma",
  "Договор не принадлежит выбранному клиенту.": "Shartnoma tanlangan mijozga tegishli emas.",
  "Договоры": "Shartnomalar",
  "Документ": "Hujjat",
  "Документ поставщика": "Yetkazib beruvchi hujjati",
  "Документ, задание или причина": "Hujjat, vazifa yoki sabab",
  "Документы прихода": "Jamoat hujjatlari",
  "Должность": "Lavozim",
  "Допустимые переходы статуса заказа и обязательные поля в безопасных пределах.": "Qabul qilinadigan buyurtma holati o‘tishlari va xavfsiz chegaralar ichida talab qilinadigan maydonlar.",
  "Допустимый аналог": "Qabul qilinadigan analog",
  "Допустимый аналог после согласования технологом": "Texnolog tomonidan tasdiqlanganidan keyin qabul qilinadigan analog",
  "доработка": "qayta ishlash",
  "Доработка": "Qayta ishlash",
  "Доработка и повторная приемка": "Qayta ishlash va qayta qabul qilish",
  "Доработка уже завершена или недоступна.": "Qayta ishlash allaqachon tugallangan yoki mavjud emas.",
  "Доступ": "Kirish",
  "Доступ только для просмотра": "Faqat ko‘rish uchun ruxsat",
  "Доступно": "Mavjud",
  "Доступно к принятию только {source_quantity - totals['accepted']}.": "Qabul qilish uchun faqat {source_quantity - totals['accepted']} mavjud.",
  "Доступность": "Mavjudligi",
  "Доступны отчеты: production, defects, orders, payroll.": "Hisobotlar mavjud: ishlab chiqarish, nuqsonlar, buyurtmalar, ish haqi.",
  "Доступны форматы xlsx и pdf.": "xlsx va pdf formatlari mavjud.",
  "Другое": "Boshqa",
  "Другой": "Boshqa",
  "дублирующая строка в файле": "fayldagi ikki nusxadagi qator",
  "ед.": "birlik",
  "Ед.": "Birlik",
  "Единая карточка сотрудника, рабочий календарь и фактическое присутствие без удаления кадровой истории.": "Xodimlar tarixini o‘chirmasdan, bitta xodim kartasi, ish taqvimi va haqiqiy mavjudligi.",
  "Единая рабочая область для компонентов, фоновых заданий, ошибок, миграции и восстановления.": "Komponentlar, fon ishlari, xatolar, migratsiya va tiklash uchun yagona ish maydoni.",
  "Единая сверка незавершенного производства по партиям, операциям и рабочим центрам.": "Partiyalar, operatsiyalar va ish markazlari bo‘yicha tugallanmagan ishlarni yagona muvofiqlashtirish.",
  "Единица": "Birlik",
  "Единицы": "Birliklar",
  "Единицы измерения": "O‘lchov birliklari",
  "Единый производственный контур": "Yagona ishlab chiqarish konturi",
  "Если остаток изменился после начала пересчета, проведение будет заблокировано.": "Qayta hisoblash boshlanganidan keyin balans o‘zgargan bo‘lsa, tranzaktsiya bloklanadi.",
  "Журнал аудита": "Audit jurnali",
  "Журнал документов": "Hujjatlar jurnali",
  "Журнал системных заданий является append-only.": "Tizim vazifalari jurnali faqat qo‘shish uchun mo‘ljallangan.",
  "За период нет данных": "Davr uchun ma'lumotlar yo‘q",
  "Заблокирован": "Bloklangan",
  "Заблокирована": "Bloklangan",
  "Завершен": "Bajarildi",
  "Завершена": "Bajarildi",
  "Завершение и возврат не могут превышать принятое количество.": "To‘ldirish va qaytarish qabul qilingan miqdordan oshmasligi kerak.",
  "Завершение отделки должно подтверждать весь план задания.": "Tugatishning tugallanishi butun ish rejasini tasdiqlashi kerak.",
  "Завершение пошива для сквозного сценария этапа 4": "4-bosqichning oxirigacha stsenariysi uchun tikuvni yakunlash",
  "Завершенная проверка ОТК является неизменяемой.": "Tugallangan QC tekshiruvi o‘zgarmasdir.",
  "Завершено": "Bajarildi",
  "Завершить": "Bajarildi",
  "Завершить можно только выполняемое задание.": "Faqat bajarilayotgan vazifani bajarish mumkin.",
  "Завершить можно только черновик проверки.": "Siz faqat qoralama ko‘rib chiqishni yakunlashingiz mumkin.",
  "Завершить раскрой": "Kesishni tugating",
  "Загружаем журнал ОТК": "Sifat nazorati jurnali yuklanmoqda",
  "Загружаем задания на доработку": "Tekshirish uchun topshiriqlar yuklanmoqda",
  "Загружаем задания пошива": "Tikuv ishlari yuklanmoqda",
  "Загружаем задания раскроя": "Kesish vazifalari yuklanmoqda",
  "Загружаем отгрузки": "Yuklarni yuklash",
  "Загружаем производственные заказы": "Ishlab chiqarish buyurtmalarini yuklash",
  "Загружаем реестр дефектов": "Kamchiliklar reestri yuklanmoqda",
  "Загружаем технологические маршруты": "Texnologik marshrutlarni yuklash",
  "Загружаем упаковочный контур": "Qadoqlash sxemasi yuklanmoqda",
  "Загрузка данных": "Ma'lumotlar yuklanmoqda",
  "Загрузка рабочих центров, выпуск, WIP и дефекты для оперативного управления сменой.": "Ish markazlarini yuklash, bo‘shatish, WIP va operatsion smenani boshqarish uchun nuqsonlar.",
  "Загрузка…": "Yuklanmoqda…",
  "Задание": "Kvest",
  "Задание отделки": "Tugatish vazifasi",
  "Задание относится к другой организации.": "Topshiriq boshqa tashkilotga tegishli.",
  "Задание раскроя": "Kesish vazifasi",
  "Заданий на доработку нет": "Qayta ishlash uchun vazifalar yo‘q",
  "Заданий отделки пока нет": "Hali yakuniy vazifalar yo‘q",
  "Заданий пошива пока нет": "Hali tikuvchilik vazifalari yo‘q",
  "Заданий раскроя пока нет": "Hali hech qanday kesish vazifalari yo‘q",
  "Задания": "Kvestlar",
  "Задания на доработку не удаляются. Используйте отмену.": "Tekshirish vazifalari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Задания отделки не удаляются.": "Tugatish ishlari o‘chirilmaydi.",
  "Задания раскроя не удаляются. Используйте отмену.": "Kesish ishlari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Задержка": "Kechikish",
  "Заказ": "Buyurtma",
  "Заказ клиента": "Mijoz buyurtmasi",
  "Заказ клиента · редакция {0}": "Mijoz buyurtmasi · {0}-tahrir",
  "Заказ не найден.": "Buyurtma topilmadi.",
  "Заказ относится к другой организации.": "Buyurtma boshqa tashkilotga tegishli.",
  "Заказ поставщику": "Yetkazib beruvchiga buyurtma berish",
  "Заказ поставщику {order.code}": "{order.code} yetkazib beruvchiga buyurtma bering",
  "Заказ поставщику не находится в приемке.": "Yetkazib beruvchiga buyurtma qabul qilinmayapti.",
  "Заказ складского документа не совпадает с производственной партией.": "Ombor hujjati buyurtmasi ishlab chiqarish partiyasiga mos kelmaydi.",
  "Заказ создан": "Buyurtma yaratildi",
  "Заказ уже отменен или закрыт.": "Buyurtma allaqachon bekor qilingan yoki yopilgan.",
  "Заказ: {shipment.order.code}": "Buyurtma: {shipment.order.code}",
  "Заказано": "Buyurtma qilingan",
  "заказов": "buyurtmalar",
  "Заказы": "Buyurtmalar",
  "Заказы / просрочка": "Buyurtmalar/kech",
  "Заказы не удаляются. Используйте отмену.": "Buyurtmalar o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Заказы поставщикам": "Yetkazib beruvchilarga buyurtmalar",
  "Заказы поставщикам не удаляются. Используйте отмену.": "Yetkazib beruvchilarga buyurtmalar o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Закрыт": "Yopiq",
  "Закрыть": "Yopish",
  "Закрыть заказ": "Buyurtmani yopish",
  "Закрыть заказ по недопоставке": "Yetkazib berilmaganligi sababli buyurtmani yoping",
  "Закрыть меню": "Menyuni yopish",
  "Закупка": "Sotib olish",
  "Закупки": "Xaridlar",
  "Закупщик": "Xaridor",
  "Заменена": "O‘zgartirildi",
  "Замещение директора на период командировки": "Direktorni xizmat safariga almashtirish",
  "Записать настил": "Rekord taxta",
  "Записать присутствие": "Mavjudlikni qayd etish",
  "Записать факт": "Bir fakt yozing",
  "записей · страница": "yozuv · sahifa",
  "записи · страница": "yozuv · sahifa",
  "запись · страница": "yozuv · sahifa",
  "Записей не найдено": "Hech qanday yozuv topilmadi",
  "Записи нельзя изменить или удалить": "Yozuvlarni o‘zgartirish yoki o‘chirish mumkin emas",
  "Записываем…": "Keling, yozib olamiz ...",
  "Запланирован": "Rejalashtirilgan",
  "Запланирована": "Rejalashtirilgan",
  "Запланировано": "Rejalashtirilgan",
  "Запланировать": "Jadval",
  "Запланировать можно только черновик производственного заказа.": "Siz faqat qoralama ishlab chiqarish buyurtmasini rejalashtirishingiz mumkin.",
  "Заполните обязательные поля.": "Kerakli maydonlarni to‘ldiring.",
  "Заполните шапку, добавьте позиции и распределите количество по размерной сетке.": "Sarlavhani to‘ldiring, elementlarni qo‘shing va miqdorlarni o‘lcham jadvaliga muvofiq taqsimlang.",
  "Запуск": "Ishga tushirish",
  "запуск · надежность · контроль": "ishga tushirish · ishonchlilik · nazorat qilish",
  "Запустите зашифрованный backup и restore drill по эксплуатационному регламенту. Отсутствие проверки вызывает alert.": "Operatsion qoidalarga muvofiq shifrlangan zaxira nusxasini ishga tushiring va matkapni tiklang. Tekshirishning yo‘qligi ogohlantirishni keltirib chiqaradi.",
  "Запустите расчет, чтобы собрать принятые производственные события.": "Qabul qilingan ishlab chiqarish hodisalarini to‘plash uchun hisob-kitobni bajaring.",
  "Запустить проверку": "Skanerlashni ishga tushiring",
  "Зарегистрируйте минимум один настил.": "Kamida bitta qavatni ro‘yxatdan o‘tkazing.",
  "Зарезервировано": "Zaxiralangan",
  "Зарезервировать": "Zaxira",
  "Зарина": "Zarina",
  "Зафиксировал": "Yozib olingan",
  "Зафиксированная спецификация": "Qayd etilgan spetsifikatsiya",
  "Зафиксированная спецификация материалов объясняет каждую потребность и не меняется после использования.": "Belgilangan materiallar ro‘yxati har qanday ehtiyojni tushuntiradi va foydalanishdan keyin o‘zgarmaydi.",
  "Зафиксированные дефекты не удаляются.": "Ruxsat etilgan nuqsonlar o‘chirilmaydi.",
  "Зафиксировано": "Yozib olingan",
  "Зафиксировать": "Qabul qiling",
  "Зафиксировать навсегда": "Abadiy tuzating",
  "Зафиксировать простой · {0}": "Oddiy {0}ni tuzating",
  "Зафиксируйте порядок операций, рабочие центры и норматив времени до выпуска производственного заказа.": "Ishlab chiqarish buyurtmasini chiqarishdan oldin operatsiyalar tartibini, ish markazlarini va vaqt standartlarini yozib oling.",
  "Защищенный контур": "Himoyalangan kontur",
  "Заявка": "So‘rov",
  "Заявка из дефицита": "Kamchilikdan ariza",
  "Заявки": "So‘rovlar",
  "Заявки на закупку не удаляются. Используйте отмену.": "Xarid so‘rovlari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Заявки не удаляются. Используйте отмену.": "Ilovalar o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Зебо": "Zebo",
  "Знаков после запятой": "O‘nlik joylari",
  "Знаковое изменение остатка": "Imzolangan qoldiq o‘zgarishi",
  "Значение": "Ma'nosi",
  "Значение (JSON)": "Qiymat (JSON)",
  "Значительный": "Muhim",
  "Зона": "Zona",
  "идет": "kelayotgan",
  "из": "dan",
  "Из ячейки": "Katakdan",
  "изделие": "mahsulot",
  "Изделие": "Mahsulot",
  "Изделия / конструкторская база": "Mahsulotlar / dizayn bazasi",
  "Изменен": "O‘zgartirildi",
  "Изменение записи": "Kirishni o‘zgartirish",
  "Изменения будут зафиксированы в журнале аудита.": "O‘zgarishlar audit jurnalida qayd etiladi.",
  "Измените даты или выберите другой отчет.": "Sanalarni o‘zgartiring yoki boshqa hisobotni tanlang.",
  "Измените фильтры или создайте новую запись.": "Filtrlarni o‘zgartiring yoki yangi yozuv yarating.",
  "Изменить": "O‘zgartirish",
  "Изменять можно только собственные представления.": "Siz faqat o‘z qarashlaringizni o‘zgartirishingiz mumkin.",
  "Изменять можно только черновик заказа поставщику.": "Siz buyurtma loyihasini faqat etkazib beruvchiga o‘zgartirishingiz mumkin.",
  "Изменять можно только черновик заявки.": "Faqat qoralama arizani o‘zgartirish mumkin.",
  "Израсходована": "Sarflangan",
  "Импорт завершился с ошибками.": "Import xatoliklar bilan yakunlandi.",
  "Импорт: {batch.get_import_type_display()}": "Import: {batch.get_import_type_display()}",
  "Имя": "Ism",
  "Инвентаризации не удаляются.": "Inventarizatsiya o‘chirilmaydi.",
  "Инвентаризационные ведомости": "Inventar varaqlari",
  "Инвентаризация": "Inventarizatsiya",
  "Инициатор": "Tashabbuschi",
  "ИНН": "TIN",
  "Инспектор": "Inspektor",
  "Инспектор ОТК": "Sifat nazorati inspektori",
  "Интеграционных ошибок нет": "Integratsiya xatosi yo‘q",
  "Информация": "Ma'lumot",
  "Исмоилов": "Ismoilov",
  "Исполнение": "Ijro",
  "Исполнитель": "Ijrochi",
  "Исполнитель / рабочий": "Ijrochi/ishchi",
  "Исполнитель не найден.": "Rassom topilmadi.",
  "Использован": "Ishlatilgan",
  "Использованную или активированную версию BOM удалить нельзя.": "BOM ning ishlatilgan yoki faollashtirilgan versiyasini o‘chirib bo‘lmaydi.",
  "Использовано": "Ishlatilgan",
  "Используйте действующий технологический маршрут.": "Yaroqli jarayon marshrutidan foydalaning.",
  "Используйте учетную запись, выданную администратором.": "Administrator tomonidan berilgan hisob qaydnomasidan foydalaning.",
  "Используйте формат YYYY-MM-DD.": "YYYY-MM-DD formatidan foydalaning.",
  "Исправление не затирает исходный результат: после выполнения система создает новый цикл ОТК.": "Tuzatish asl natijani qayta yozmaydi: bajarilgandan so‘ng tizim yangi QC tsiklini yaratadi.",
  "История контроля": "Nazorat tarixi",
  "История приемки": "Qabul qilish tarixi",
  "Источник": "Manba",
  "Источник / участок": "Manba/sayt",
  "Исходный или заменяющий материал": "Asl yoki almashtiriladigan material",
  "Исходный материал": "Manba materiali",
  "Итоги настилов не совпадают с итогами задания по расходу, возврату, отходу или браку.": "Zaminlash natijalari iste'mol, qaytarish, chiqindilar yoki hurda uchun topshiriq natijalariga mos kelmaydi.",
  "Итоги редакции": "Tahrir yakuni",
  "К отгрузке должен быть привязан хотя бы один принятый на склад короб.": "Omborda olingan kamida bitta quti jo‘natishga biriktirilgan bo‘lishi kerak.",
  "К реестру": "Ro‘yxatga qaytish",
  "К-18/26": "K-18/26",
  "Каждая колонка ниже — отдельный неизменяемый срез нормы.": "Quyidagi har bir ustun normaning alohida, o‘zgarmas qismidir.",
  "Каждая сумма": "Har bir summa",
  "Каждое задание связывает резерв материала, фактический настил, расход, возврат, отход и выпущенные комплекты.": "Har bir ish material zahirasi, haqiqiy taxta, iste'mol, qaytarish, chiqindilar va chiqarilgan to‘plamlarni bog‘laydi.",
  "Каждый дефект связан с проверкой, исходной операцией и ответственным рабочим центром.": "Har bir nuqson tekshiruv, original operatsiya va mas'uliyatli ish markazi bilan bog‘liq.",
  "Камол": "Kamol",
  "Канал / операция": "Kanal/operatsiya",
  "Каримов": "Karimov",
  "Карточки изделий, размерные сетки, цветовые исполнения и комплектации.": "Mahsulot kartalari, o‘lchamli panjaralar, rangli versiyalar va konfiguratsiyalar.",
  "Карточки сотрудников не удаляются. Используйте статус.": "Xodimlarning kartalari o‘chirilmaydi. Holatdan foydalaning.",
  "Категории материалов": "Materiallar toifalari",
  "Категория": "Turkum",
  "Категория дефекта": "Kamchiliklar toifasi",
  "Категория дефекта не найдена.": "Kamchiliklar toifasi topilmadi.",
  "Категория дефекта относится к другой организации.": "Qusur toifasi boshqa tashkilotga tegishli.",
  "Качество": "Sifat",
  "КБ": "KB",
  "Кладовщик сырья": "Xom ashyo omborchisi",
  "Клиент": "Mijoz",
  "Клиент, договор, срок и ответственный менеджер.": "Mijoz, shartnoma, muddat va mas'ul menejer.",
  "Клиент: {order.client.name}<br/>Дата готовности: {order.due_date:%d.%m.%Y}<br/>Редакция: {order.current_revision.number}": "Mijoz: {order.client.name}<br/>Tayyor sana: {order.due_date:%d.%m.%Y}<br/>Nashr: {order.current_revision.number}",
  "Клиенты": "Mijozlar",
  "Клиенты и контакты": "Mijozlar va kontaktlar",
  "Ключ": "Kalit",
  "Ключ уже использован для другого задания.": "Kalit allaqachon boshqa vazifa uchun ishlatilgan.",
  "Код": "Kod",
  "Код 2FA": "2FA kodi",
  "Код варианта": "Variant kodi",
  "Код дефекта": "Kamchilik kodi",
  "Код заказа": "Buyurtma kodi",
  "Код заказа, клиент, договор": "Buyurtma kodi, mijoz, shartnoma",
  "Код клиента": "Mijoz kodi",
  "Код модели": "Model kodi",
  "Код организации": "Tashkilot kodi",
  "Код роли": "Rol kodi",
  "Код ячейки": "Katak kodi",
  "Код BOM": "BOM kodi",
  "Код, вариант, модель": "Kod, variant, model",
  "Код, модель или цвет": "Kod, model yoki rang",
  "Код, название, ИНН": "Kod, ism, TIN",
  "Код, название, ИНН, телефон": "Kod, ism, TIN, telefon",
  "Код, название, категория": "Kod, ism, toifa",
  "Код, название, производитель": "Kod, ism, ishlab chiqaruvchi",
  "Кол-во": "Miqdor",
  "Количество": "Miqdori",
  "Количество в выбранных упаковках должно совпадать со строками отгрузки.": "Tanlangan paketlardagi miqdorlar etkazib berish liniyalariga mos kelishi kerak.",
  "Количество движения не может быть нулевым.": "Impuls nolga teng bo‘lishi mumkin emas.",
  "Количество должно совпадать с выбранным коробом и быть доступно в остатке.": "Miqdor tanlangan qutiga mos kelishi va qolgan qismida mavjud bo‘lishi kerak.",
  "Количество проверки и результаты должны быть неотрицательными.": "Sinovlar soni va natijalar salbiy bo‘lmasligi kerak.",
  "Количество размера {0}": "Miqdor hajmi {0}",
  "Количество резерва должно быть больше нуля.": "Zaxira miqdori noldan katta bo‘lishi kerak.",
  "Количество строки рассчитывается как сумма заполненных размеров.": "Chiziqlar soni to‘ldirilgan o‘lchamlarning yig‘indisi sifatida hisoblanadi.",
  "Количество: {package.items.aggregate(total=Sum('quantity'))['total'] or 0}": "Miqdori: {package.items.aggregate(total=Sum('quantity'))['total'] or 0}",
  "Команда движения": "Harakat buyrug‘i",
  "Комментарии": "Fikrlar",
  "Комментарий": "Izoh",
  "Комментарий к редакции": "Tahririyatga sharh",
  "компл.": "o‘rnatish",
  "Комплект": "Kit",
  "Комплект не найден.": "Kit topilmadi.",
  "Комплект относится к другой организации.": "To‘plam boshqa tashkilotga tegishli.",
  "Комплект после отделки": "Tugatgandan keyin o‘rnating",
  "Комплект с завершенным пошивом": "Tugallangan tikuv bilan to‘plam",
  "Комплектация (JSON)": "Uskunalar (JSON)",
  "Комплектность": "To‘liqlik",
  "Комплектность {item.bundle.code} не подтверждена: {', '.join(missing)}.": "{item.bundle.code} to‘liqligi tasdiqlanmagan: {', '.join(missing)}.",
  "Комплектность подтверждается сервером при запечатывании.": "To‘liqlik muhrlangandan so‘ng server tomonidan tasdiqlanadi.",
  "Комплектов": "Setlar",
  "Комплектов пока нет": "Hali to‘plamlar mavjud emas",
  "Комплектов фактически": "To‘plamlar aslida",
  "Комплектование": "Sotib olish",
  "Комплектовочная ведомость": "Tanlash ro‘yxati",
  "КОМПЛЕКТОВОЧНАЯ ВЕДОМОСТЬ": "QO‘DLASH VRAGI",
  "Комплекты + брак должны равняться фактическому выпуску настилов.": "To‘plamlar + hurdalar taxtalarning haqiqiy ishlab chiqarishiga teng bo‘lishi kerak.",
  "Комплекты кроя": "Kesish to‘plamlari",
  "Комплекты кроя не удаляются.": "Kesish to‘plamlari o‘chirilmaydi.",
  "Комплекты после раскроя": "Kesishdan keyin to‘plamlar",
  "Конструктор отчетов": "Hisobot dizayneri",
  "Контролируемый CSV-импорт": "Boshqariladigan CSV importi",
  "Контроль": "Nazorat",
  "Контроль выпуска за 30 дней": "30 kun ichida nazoratni chiqaring",
  "Контроль заказов": "Buyurtma nazorati",
  "Контроль качества": "Sifat nazorati",
  "Контроль качества и упаковка": "Sifat nazorati va qadoqlash",
  "Контрольная проверка уведомлений этапа 6": "6-bosqich bildirishnomalar roʻyxati",
  "Контрольная точка остатка": "Qolgan nazorat punkti",
  "Контрольные суммы": "Tekshirish summalari",
  "Контрольный период": "Nazorat davri",
  "Контур кадров и оплаты": "Xodimlar va to‘lov sxemasi",
  "Контур обеспечения": "Ta'minot sxemasi",
  "Контур производства": "Ishlab chiqarish sxemasi",
  "Контур расчета материалов": "Materiallarni hisoblash tsikli",
  "Контур руководителя": "Lider doirasi",
  "Копировать заказ": "Buyurtmani nusxalash",
  "Копия": "Nusxalash",
  "Копия заказа {source_order.code}": "{source_order.code} buyurtma nusxasi",
  "Короб": "Quti",
  "Короб на складе ГП": "GP omboridagi quti",
  "Короба": "Quti",
  "Короба и комплекты": "Qutilar va to‘plamlar",
  "Короба:": "Quti:",
  "Короткоживущий JWT в HttpOnly cookie; изменяющие запросы также требуют X-CSRFToken.": "HttpOnly cookie faylida qisqa muddatli JWT; so‘rovlarni o‘zgartirish uchun X-CSRFToken ham talab qilinadi.",
  "Корректировка": "Sozlash",
  "Корректировка инвентаризации": "Inventarizatsiyani sozlash",
  "Коэффициент": "Koeffitsient",
  "Краткое название": "Qisqa ism",
  "Критический": "Tanqidiy",
  "Критический дефицит": "Kritik tanqislik",
  "Критических": "Tanqidiy",
  "Критично": "Tanqidiy",
  "Куртка полевая": "Dala ko‘ylagi",
  "Куртка полевая · оливковая": "Dala ko‘ylagi zaytun",
  "Куртка прямого силуэта с усиленными накладками.": "Kuchli qoplamali tekis siluet ko‘ylagi.",
  "Куртки": "Kurtkalar",
  "Логин": "Kirish",
  "Логин ответственного пользователя": "Mas'uliyatli foydalanuvchi login",
  "Логин, имя или e-mail": "Kirish, ism yoki elektron pochta",
  "Логистика / исполнение заказа": "Logistika / buyurtmani bajarish",
  "лот": "ko‘p",
  "Лот не соответствует материалу задания.": "Lot topshiriq materialiga mos kelmaydi.",
  "Любой приоритет": "Har qanday ustuvorlik",
  "м": "m",
  "м ×": "m ×",
  "Мадина": "Madina",
  "Малика": "Malika",
  "Маркировка:": "Belgilash:",
  "Маршрут": "Marshrut",
  "Маршрут / операция": "Marshrut/operatsiya",
  "Маршрут комплекта": "To‘plam yo‘nalishi",
  "Маршрут пошива": "Tikuv yo‘nalishi",
  "Маршрут пошива брюк полевых": "Dala shimlari uchun tikuv yo‘nalishi",
  "Маршрут пошива куртки полевой": "Dala ko‘ylagi uchun tikuv yo‘nalishi",
  "Маршрут этапа 3": "3-bosqich marshruti",
  "Маршрутов пока нет": "Hozircha marshrutlar yo‘q",
  "Мастер раскроя": "Kesish ustasi",
  "Мастер швейного участка": "Tikuv uchastkasi ustasi",
  "материал": "material",
  "Материал": "Material",
  "Материал / источник нормы": "Material/standart manba",
  "Материал / лот / ячейка": "Materiallar / lot / katak",
  "Материал / партия": "Material/partiya",
  "Материал выдан": "Chiqarilgan material",
  "Материал задания не входит в зафиксированную потребность строки заказа.": "Ish materiallari buyurtma chizig‘ining qayd etilgan talabining bir qismi emas.",
  "Материал или единица строки {line.line_number} не совпадает с заявкой.": "{line.line_number} materiali yoki chiziq birligi talabga mos kelmaydi.",
  "Материал к выдаче": "Chiqarish uchun material",
  "Материал можно выдать только по черновику задания.": "Materiallar faqat topshiriq loyihasi asosida berilishi mumkin.",
  "Материал не включен в список разрешенных аналогов.": "Materiallar tasdiqlangan analoglar ro‘yxatiga kiritilmagan.",
  "Материал не найден.": "Hech qanday material topilmadi.",
  "Материал не совпадает с потребностью.": "Materiallar talabga mos kelmaydi.",
  "Материал не совпадает со строкой заказа.": "Materiallar buyurtma chizig‘iga mos kelmaydi.",
  "Материал не совпадает со строкой заявки.": "Material so‘rov chizig‘iga mos kelmaydi.",
  "Материал строки не совпадает с заказом поставщику.": "Chiziq materiali yetkazib beruvchiga buyurtmaga mos kelmaydi.",
  "Материал, план": "Material, reja",
  "материалов": "materiallar",
  "Материалы": "Materiallar",
  "Материалы / нормативная база": "Materiallar / me'yoriy-huquqiy baza",
  "Материалы выданы": "Chiqarilgan materiallar",
  "Материалы и поставщики": "Materiallar va yetkazib beruvchilar",
  "Материалы этапа {stage} · {batch.code}": "Sahna materiallari {stage} {batch.code}",
  "между приемкой и завершением операций": "operatsiyalarni qabul qilish va tugatish o‘rtasida",
  "Менеджер": "Menejer",
  "Менеджер по заказам": "Buyurtma menejeri",
  "Метр": "Metr",
  "Миграция данных": "Ma'lumotlarni ko‘chirish",
  "мин": "daq",
  "Минимальный запас": "Minimal zaxira",
  "Минимальный остаток": "Minimal balans",
  "Минимум": "Minimal",
  "Минут": "daqiqa",
  "Мирзаева": "Mirzaeva",
  "Модели": "Modellar",
  "Модели и варианты": "Modellar va variantlar",
  "Модель": "Model",
  "Модель / вариант": "Model/variant",
  "Модель: {package.batch.production_order.order_line.product_variant.code}": "Model: {package.batch.production_order.order_line.product_variant.code}",
  "Модель/вариант": "Model/variant",
  "Можно редактировать только свой комментарий.": "Siz faqat sharhingizni tahrirlashingiz mumkin.",
  "Молнии": "Chaqmoq",
  "мс": "ms",
  "Мужская форменная сетка": "Erkaklar formasi",
  "На отделку доступно {available} принятого ОТК количества.": "Sifat nazorati bo‘limi tomonidan qabul qilingan {available} miqdori tugatish uchun mavjud.",
  "На ОТК передается только комплект с завершенным пошивом.": "Sifatni nazorat qilish bo‘limiga faqat tikilgan to‘liq to‘plam beriladi.",
  "На склад": "Omborga",
  "На склад поступает только принятая ОТК и запечатанная продукция; каждое изменение подтверждается движением.": "Omborga faqat sifat nazorati bo‘limi tomonidan qabul qilingan va muhrlangan mahsulotlar etkazib beriladi; Har bir o‘zgarish harakat bilan tasdiqlanadi.",
  "На согласовании": "Kelishilgan bo‘lish",
  "На согласовании нет активной замены материала.": "Tasdiqlash bo‘yicha materialni faol almashtirish yo‘q.",
  "Назад": "Orqaga",
  "Название": "Sarlavha",
  "Название / предмет": "Sarlavha/element",
  "Название исполнения": "Ishlash nomi",
  "Название представления": "Shou sarlavhasi",
  "Назначена": "Tayinlangan",
  "Назначение": "Tayinlov",
  "Назначение относится к другому сотруднику.": "Topshiriq boshqa xodimga tegishli.",
  "Назначение смены": "Shift topshirig‘i",
  "Назначения": "Tayinlovlar",
  "Назначено": "Tayinlangan",
  "Назначить смену": "Shift tayinlash",
  "Наименование операции": "Operatsiya nomi",
  "Накладная": "Hisob-faktura",
  "Накладная / счет-фактура": "Yetkazib berish to‘g‘risidagi eslatma/faktura",
  "Накладная STS-2408": "STS-2408 yuk xati",
  "Например, по 10 штук в коробе": "Misol uchun, har bir qutiga 10 dona",
  "Например: клиент изменил размерный ряд": "Masalan: mijoz o‘lcham oralig‘ini o‘zgartirdi",
  "Например: План-факт за месяц": "Masalan: Oylik reja",
  "Нарушение отделочной строчки: 4 изделия на доработку, 2 в окончательный брак.": "Tugatish tikuvining buzilishi: qayta ishlash uchun 4 ta element, yakuniy hurda uchun 2 ta.",
  "Насиров": "Nasirov",
  "Настил": "Zamin qoplamasi",
  "Настил регистрируется только по выполняемому заданию.": "Zamin qoplamasi faqat bajarilayotgan ish uchun ro‘yxatga olinadi.",
  "Настил №": "Zamin raqami",
  "Настраиваемые внутрисистемные сигналы о дефиците, просрочке, доработке, готовности к отгрузке и начислениях.": "Kamchiliklar, kechikishlar, qayta ishlash, jo‘natishga tayyorlik va to‘lovlar haqida sozlanishi mumkin bo‘lgan tizim ichidagi signallar.",
  "Настройка": "Sozlamalar",
  "Настройки": "Sozlamalar",
  "Настройки организации, пороги и правила, доступные без изменения кода.": "Tashkilot sozlamalari, chegaralari va qoidalari kodni o‘zgartirmasdan mavjud.",
  "Начало": "Uy",
  "Начало (HH:MM)": "Boshlash (SS:MM)",
  "Начало периода": "Davrning boshlanishi",
  "Начальник отдела снабжения": "Ta'minot bo‘limi boshlig‘i",
  "Начальник производства": "Ishlab chiqarish bo‘limi boshlig‘i",
  "Начальные демонстрационные остатки производственного контура": "Ishlab chiqarish sxemasining dastlabki namoyish qoldiqlari",
  "Начальные остатки": "Ochilish balanslari",
  "Начать": "Boshlash",
  "Начать можно только задание с выданным материалом.": "Siz faqat berilgan material bilan vazifani boshlashingiz mumkin.",
  "Начать можно только назначенную доработку.": "Siz faqat tayinlangan tahrirni boshlashingiz mumkin.",
  "Начать раскрой": "Kesishni boshlang",
  "Начисление": "Hisob-kitob",
  "Начисления": "Hisoblashlar",
  "Начисления готовы": "Hisob-kitoblar tayyor",
  "Начисления к утверждению": "Tasdiqlanishi kerak bo‘lgan hisob-kitoblar",
  "Не выбрано": "Tanlanmagan",
  "Не запрошена": "Soʻralmagan",
  "Не назначен": "Tayinlanmagan",
  "не назначена": "tayinlanmagan",
  "Не назначено": "Tayinlanmagan",
  "Не найден открытый простой.": "Ochiq uzilish vaqti topilmadi.",
  "Не найдено исходное движение приемки.": "Asl qabul qilish harakati topilmadi.",
  "Не оплачивать": "To‘lamang",
  "Не удалось восстановить использованный резерв при сторно.": "Ishlatilgan zahirani bekor qilingandan keyin tiklab bo‘lmadi.",
  "Не удалось выполнить действие.": "Amal bajarilmadi.",
  "Не удалось загрузить данные": "Maʼlumotlarni yuklab boʻlmadi",
  "Не указана": "Belgilanmagan",
  "Неактивен": "Faol emas",
  "Неверный логин или пароль.": "Yaroqsiz login yoki parol.",
  "Неверный тип токена.": "Token turi yaroqsiz.",
  "Недействительная сессия.": "Seans yaroqsiz.",
  "Недопоставка:": "Qisqa yetkazib berish:",
  "Недопустимое значение.": "Noto‘g‘ri qiymat.",
  "Недостаточно остатка по партии {lot.internal_lot} в ячейке {location.code}.": "{location.code} katagida {lot.internal_lot} to‘plami uchun balans yetarli emas.",
  "Недостаточно резерва материала {effective.code}; не хватает {remaining}.": "{effective.code} moddiy zaxiraning yetarli emasligi; {remaining} yo‘q.",
  "Недоступен": "Mavjud emas",
  "Незначительный": "Kichik",
  "Неизвестный обработчик системного задания: {job.task_name}": "Noma'lum tizim vazifasini bajaruvchisi: {job.task_name}",
  "Неизвестный тип импорта.": "Noma'lum import turi.",
  "Неизменяемая история": "O‘zgarmas tarix",
  "Некомплектность": "To‘liqsizlik",
  "Некорректный период recovery run.": "Qayta tiklash davri noto‘g‘ri.",
  "Некорректный тип. Ожидалось значение первичного ключа, получен str.": "Noto‘g‘ri tur. Birlamchi kalit qiymati kutilgan edi.",
  "Нельзя деактивировать собственную учетную запись.": "Siz o‘z hisobingizni o‘chira olmaysiz.",
  "Нельзя делегировать права самому себе.": "Siz huquqlarni o‘zingizga topshira olmaysiz.",
  "Нельзя менять материал после резервирования или отправки в закупку.": "Materialni zahiraga olingandan yoki sotib olishga yuborilgandan keyin o‘zgartira olmaysiz.",
  "Нельзя создать делегирование, завершившееся в прошлом.": "Siz o‘tmishda tugagan delegatsiyani yarata olmaysiz.",
  "Необязательно": "Ixtiyoriy",
  "Непрочитанные": "Oʻqilmagan",
  "Несколько ролей на пользователя, деактивация без удаления истории и восстановление доступа.": "Har bir foydalanuvchi uchun bir nechta rollar, tarixni o‘chirmasdan o‘chirish va kirishni tiklash.",
  "нет": "yo‘q",
  "Нет": "Yo‘q",
  "Нет дневных фактов": "Kundalik faktlar yo‘q",
  "Нет доступа": "Kirish huquqi yo‘q",
  "Нет зарегистрированных проверок восстановления": "Qayta tiklash tekshiruvlari qayd etilmagan",
  "Нет плановых данных за период": "Davr uchun rejalashtirilgan ma'lumotlar yo‘q",
  "Нет утвержденной расценки для операции {operation.code} на {occurred_at:%d.%m.%Y}.": "{operation.code} dan {occurred_at:%d.%m.%Y} gacha bo‘lgan operatsiya uchun tasdiqlangan narx yo‘q.",
  "Низкий": "Qisqa",
  "Нитки": "Iplar",
  "Нить армированная №40 оливковая": "40-sonli mustahkamlangan ip zaytun",
  "Новая ведомость": "Yangi qaydnoma",
  "Новая версия": "Yangi versiya",
  "Новая единица": "Yangi birlik",
  "Новая категория": "Yangi kategoriya",
  "Новая модель": "Yangi model",
  "Новая отгрузка": "Yangi jo‘natish",
  "Новая периодическая расценка": "Yangi davriy stavka",
  "Новая площадка": "Yangi sayt",
  "Новая приемка": "Yangi qabul",
  "Новая проверка": "Yangi chek",
  "Новая расценка": "Yangi narx",
  "Новая расчетная ведомость": "Yangi ish haqi varaqasi",
  "Новая редакция": "Yangi nashr",
  "Новая редакция нормы": "Normning yangi nashri",
  "Новая роль": "Yangi rol",
  "Новая сетка": "Yangi panjara",
  "Новая частичная отгрузка": "Yangi qisman jo‘natish",
  "Новая ячейка": "Yangi katak",
  "Новое задание раскроя": "Yangi kesish ishi",
  "Новое подразделение": "Yangi bo‘linma",
  "Новый аналог": "Yangi analog",
  "Новый вариант": "Yangi variant",
  "Новый договор": "Yangi shartnoma",
  "Новый документ": "Yangi hujjat",
  "Новый заказ": "Yangi buyurtma",
  "Новый клиент": "Yangi mijoz",
  "Новый короб": "Yangi quti",
  "Новый маршрут": "Yangi marshrut",
  "Новый материал": "Yangi material",
  "Новый параметр": "Yangi parametr",
  "Новый пользователь": "Yangi foydalanuvchi",
  "Новый поставщик": "Yangi yetkazib beruvchi",
  "Новый производственный заказ": "Yangi ishlab chiqarish buyurtmasi",
  "Новый рабочий центр": "Yangi ish markazi",
  "Новый размер": "Yangi o‘lcham",
  "Новый сезон": "Yangi mavsum",
  "Новый сертификат": "Yangi sertifikat",
  "Новый склад": "Yangi ombor",
  "Новый складской документ": "Yangi ombor hujjati",
  "Новый технологический маршрут": "Yangi texnologik yo‘nalish",
  "Новый цвет": "Yangi rang",
  "Новый BOM": "Yangi BOM",
  "Новых событий нет": "Yangi voqealar yo‘q",
  "Новых уведомлений нет.": "Yangi bildirishnomalar yo‘q.",
  "Нодира": "Nodira",
  "Номенклатура остатка не входит в размерную матрицу заказа.": "Qolgan elementlar buyurtma hajmi matritsasiga kiritilmagan.",
  "Номенклатура сырья, производители, разрешенные аналоги и документы качества.": "Xom ashyo assortimenti, ishlab chiqaruvchilar, tasdiqlangan analoglar va sifat hujjatlari.",
  "Номенклатура, размер, цвет и партия коробов должны совпадать со строками отгрузки.": "Qutilarning nomenklaturasi, o‘lchami, rangi va partiyasi yuk tashish liniyalariga mos kelishi kerak.",
  "Номер": "Raqam",
  "Номер версии": "Versiya raqami",
  "Номер договора": "Shartnoma raqami",
  "Номер, материал, поставщик": "Raqam, material, yetkazib beruvchi",
  "Номер, название или клиент": "Raqam, ism yoki mijoz",
  "Норма": "Norm",
  "Норма привязана к версии BOM; физический остаток, резерв и закупка показаны раздельно.": "Norm BOM versiyasiga bog‘langan; jismoniy balans, zaxira va sotib olish alohida ko‘rsatilgan.",
  "Нормативно-справочная информация": "Normativ va ma'lumotnoma ma'lumotlari",
  "Нужна текущая подтвержденная редакция заказа.": "Buyurtmaning joriy tasdiqlangan versiyasi talab qilinadi.",
  "Обеспечение / расчет по заказу": "Buyurtma uchun xavfsizlik / to‘lov",
  "Обеспеченность": "Xavfsizlik",
  "Обеспечено": "Taqdim etilgan",
  "Обзор": "Umumiy ko‘rinish",
  "Обновить события": "Tadbirlarni yangilash",
  "Обновление операционных уведомлений": "Operatsion bildirishnomalarni yangilash",
  "обновлено": "yangilangan",
  "Обозначение": "Belgilanish",
  "Оборудование": "Uskunalar",
  "общее": "umumiy",
  "Общее количество": "Umumiy miqdor",
  "Общее количество:": "Umumiy miqdori:",
  "Общий отход": "Umumiy chiqindilar",
  "Общий отход, %": "Umumiy chiqindilar, %",
  "Объект": "Ob'ekt",
  "Объект был изменен другим пользователем. Обновите данные и повторите действие.": "Ob'ekt boshqa foydalanuvchi tomonidan o‘zgartirilgan. Ma'lumotlarni yangilang va amalni takrorlang.",
  "Объект относится к другой организации.": "Ob'ekt boshqa tashkilotga tegishli.",
  "Обычный": "Muntazam",
  "Обязательное поле.": "Majburiy maydon.",
  "Ограничить демонстрационный сценарий указанным этапом.": "Demo skriptni belgilangan bosqichga cheklang.",
  "Один контрольный набор данных для просмотра, сохраненных представлений и экспорта без ручного пересчета таблиц.": "Jadvallarni qo‘lda qayta hisoblamasdan ko‘rish, ko‘rishlarni saqlash va eksport qilish uchun bitta asosiy ma'lumotlar to‘plami.",
  "Ожидаемая дата": "Kutilgan sana",
  "Ожидает": "Kutilmoqda",
  "ожидает утверждения": "tasdiqlashni kutmoqda",
  "Окончание": "Tugatish",
  "Окончание (HH:MM)": "Tugash (SS:MM)",
  "Окончание делегирования должно быть позже начала.": "Delegatsiyaning oxiri boshidan kechroq bo‘lishi kerak.",
  "Окончание должно быть позже начала.": "Oxiri boshidan kechroq bo‘lishi kerak.",
  "Окончание периода": "Davr oxiri",
  "Окончание периода не может быть раньше начала.": "Davrning oxiri boshidan oldin bo‘lishi mumkin emas.",
  "Оливковая": "Zaytun",
  "Оливковые": "Zaytun",
  "Оливковый": "Zaytun",
  "Оперативная кадровая сводка": "Operatsion xodimlar haqida qisqacha ma'lumot",
  "Операции": "Operatsiyalar",
  "Операции активированного или использованного маршрута изменять нельзя.": "Faollashtirilgan yoki foydalanilgan marshrutning amallarini o‘zgartirib bo‘lmaydi.",
  "Операции активированного или использованного маршрута удалять нельзя.": "Faollashtirilgan yoki foydalanilgan marshrutdagi harakatlarni o‘chirib bo‘lmaydi.",
  "Операционный контур": "Ishlash sxemasi",
  "Операция": "Operatsiya",
  "Операция дефекта не относится к маршруту партии.": "Buzilish operatsiyasi partiya yo‘nalishiga tegishli emas.",
  "Операция затрагивает зарезервированный остаток партии {lot.internal_lot}.": "Operatsiya {lot.internal_lot} ajratilgan lot balansiga ta'sir qiladi.",
  "Операция не найдена.": "Amaliyot topilmadi.",
  "Операция относится к другой организации.": "Bitim boshqa tashkilotga tegishli.",
  "Операция проводится одной командой; ledger сохраняет исходную запись и любое последующее сторно.": "Operatsiya bitta jamoa tomonidan amalga oshiriladi; daftar asl yozuvni va har qanday keyingi o‘zgartirishlarni saqlaydi.",
  "Описание": "Tavsif",
  "Организация и подразделения": "Tashkilot va bo‘linmalar",
  "Организация не найдена.": "Tashkilot topilmadi.",
  "Оргструктура": "Tashkiliy tuzilma",
  "Основание": "Baza",
  "Основная навигация": "Asosiy navigatsiya",
  "Основные реквизиты": "Asosiy tafsilotlar",
  "Осталось": "Qolgan",
  "Остатки": "Qolganlar",
  "Остатки и резервы": "Qoldiqlar va zaxiralar",
  "Остатки по модели, размеру и партии": "Model, o‘lcham va lot bo‘yicha qoldiqlar",
  "Остатки, партии и резервы": "Qoldiqlar, partiyalar va zaxiralar",
  "Остатки, резервы и ledger": "Balanslar, zaxiralar va daftar",
  "Остаток": "Qolgan",
  "Остаток ГП": "GP qoldig‘i",
  "Остаток относится к другой организации.": "Qolganlari boshqa tashkilotga tegishli.",
  "Остаток партии {line.lot.internal_lot} изменился после начала пересчета.": "Qayta hisoblash boshlanganidan beri {line.lot.internal_lot} partiyasining balansi o‘zgardi.",
  "остаток по партии уже существует с другим количеством": "partiyaning balansi allaqachon boshqa miqdor bilan mavjud",
  "Ответственный": "Mas'uliyatli",
  "Ответственный относится к другой организации.": "Mas'ul shaxs boshqa tashkilotga tegishli.",
  "Ответственный партии относится к другой организации.": "Partiyaga mas’ul shaxs boshqa tashkilotga tegishli.",
  "Ответственный пользователь не найден в организации.": "Tashkilotda mas'ul foydalanuvchi topilmadi.",
  "Отгружать можно только упаковки, принятые на склад готовой продукции.": "Faqat tayyor mahsulot omborida qabul qilingan paketlarni jo‘natish mumkin.",
  "Отгружена": "Yuborildi",
  "Отгружено": "Yuborildi",
  "Отгрузить": "Kema",
  "Отгрузка": "Yuk tashish",
  "Отгрузка превышает остаток или резерв готовой продукции.": "Yuk tashish balansi yoki tayyor mahsulot zaxirasidan oshib ketgan.",
  "Отгрузка проводится только в пределах физического остатка и активного резерва клиентского заказа.": "Yuk tashish faqat jismoniy balans va mijoz buyurtmasining faol zaxirasi doirasida amalga oshiriladi.",
  "Отгрузка уже отменена.": "Yetkazib berish allaqachon bekor qilingan.",
  "Отгрузка: {shipment.code}": "Yuk tashish: {shipment.code}",
  "Отгрузки": "Jo‘natmalar",
  "Отгрузки не удаляются. Используйте отмену.": "Yuk tashishlar o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Отгрузок пока нет": "Hozircha jo‘natmalar yo‘q",
  "Отдел заказов": "Buyurtma bo‘limi",
  "Отделка": "Tugatish",
  "Отделка, упаковка и QR": "Pardozlash, qadoqlash va QR",
  "ОТК": "Sifat nazorati",
  "ОТК / анализ причин": "Sifat nazorati / Sabablarni tahlil qilish",
  "ОТК / замкнутый цикл": "Sifat nazorati / yopiq tsikl",
  "ОТК и доработка": "Sifatni nazorat qilish va qayta ishlash",
  "ОТК и отгрузка": "Sifat nazorati va jo‘natish",
  "ОТК и повторная приемка": "Sifatni nazorat qilish va qayta qabul qilish",
  "ОТК и приемка": "Sifat nazorati va qabul qilish",
  "Отклонена": "Rad etilgan",
  "Отклонение": "Burilish",
  "отклонение +{0} дн.": "og‘ish +{0} kun.",
  "Отклонить": "Rad etish",
  "Открываем редакцию заказа": "Buyurtmani qayta ishlashni ochish",
  "Открываем технологический паспорт заказа": "Buyurtmaning texnologik pasportini ochish",
  "Открыта": "Ochiq",
  "Открыта доработка": "Tekshirish ochiq",
  "Открытая доработка": "Ochiq tahrir",
  "Открыть": "Ochiq",
  "Открыть меню": "Menyuni oching",
  "Открыть отчеты": "Hisobotlarni ochish",
  "Открыть проверку": "Chekni ochish",
  "Отмена": "Bekor qilish",
  "Отмена заказа": "Buyurtmani bekor qilish",
  "Отменен": "Bekor qilingan",
  "Отменена": "Bekor qilingan",
  "Отменено": "Bekor qilingan",
  "Отменить заказ": "Buyurtmani bekor qilish",
  "Отметить прочитанным": "O‘qilgan deb belgilang",
  "Отображаемое значение": "Ko‘rsatilgan qiymat",
  "Отправить": "Yuborish",
  "Отправить можно только непустой черновик заказа поставщику.": "Siz etkazib beruvchiga faqat bo‘sh bo‘lmagan qoralama buyurtma yuborishingiz mumkin.",
  "Отправлен": "Yuborildi",
  "Отпуск": "Dam olish",
  "Отрицательный остаток и расход чужого резерва будут заблокированы сервером.": "Salbiy qoldiq va boshqa birovning zaxirasini iste'mol qilish server tomonidan bloklanadi.",
  "Отсутствовал": "Yo‘q",
  "Отсутствуют обязательные колонки: {', '.join(sorted(missing))}.": "Kerakli ustunlar etishmayapti: {', '.join(sorted(missing))}.",
  "Оттенок": "Hue",
  "отход": "chiqindilar",
  "Отход": "Ketish",
  "Отход, %": "Chiqindi, %",
  "Отчество": "O‘rta ism",
  "Отчет": "Hisobot",
  "Отчеты": "Hisobotlar",
  "Оформить приход": "Kelganingizni ro‘yxatdan o‘tkazing",
  "Очередь": "Navbat",
  "Очередь по участкам, блокировки и отклонения видны в одном временном срезе.": "Bo‘limlar bo‘yicha navbat, blokirovkalar va og‘ishlar bir vaqtning o‘zida ko‘rinadi.",
  "Очистить поиск": "Qidiruvni tozalash",
  "Ошибка": "Xato",
  "Ошибка запроса": "So‘rov xatosi",
  "Ошибки интеграций": "Integratsiya xatolari",
  "Ошибок нет": "Xatolar yoʻq",
  "Пакет": "Paket",
  "Пакетов импорта пока нет": "Hozircha import paketlari mavjud emas",
  "Пароль": "Parol",
  "Пароль изменен, сессии завершены": "Parol o‘zgartirildi, sessiyalar tugadi",
  "Партии и рулоны": "Ko‘p va rulon",
  "Партии материала не удаляются.": "Materiallar partiyalari o‘chirilmaydi.",
  "Партии по статусам": "Status bo‘yicha partiyalar",
  "партий": "partiyalar",
  "партий · маршрут": "partiyalar · marshrut",
  "Партия": "Partiya",
  "Партия / комплект": "Lot/to‘plam",
  "Партия / материал": "Partiya/material",
  "Партия / рулон": "Lot/Roll",
  "Партия / рулон / оттенок": "Lot/roll/soya",
  "Партия / ячейка": "Partiya/katak",
  "Партия или рабочий центр относится к другой организации.": "Partiya yoki ishchilar markazi boshqa tashkilotga tegishli.",
  "Партия или ячейка относится к другой организации.": "Partiya yoki katak boshqa tashkilotga tegishli.",
  "Партия не находится на паузе.": "Partiya pauzada emas.",
  "Партия относится к другой организации.": "Partiya boshqa tashkilotga tegishli.",
  "Партия поставщика": "Yetkazib beruvchining partiyasi",
  "партия поставщика не указана": "yetkazib beruvchining partiyasi ko‘rsatilmagan",
  "Партия, материал, лот или ячейка относится к другой организации.": "Partiya, material, partiya yoki katak boshqa tashkilotga tegishli.",
  "Партия: {lot.internal_lot}": "To‘plam: {lot.internal_lot}",
  "Партия: {package.batch.code}": "To‘plam: {package.batch.code}",
  "Паспорт прохождения ОТК": "Sifat nazorati bo‘limidan o‘tish uchun pasport",
  "Пауза": "Pauza",
  "Первая партия создается вместе с заказом; позднее ее можно диспетчеризировать по участкам.": "Buyurtma bilan birga birinchi partiya yaratiladi; keyinchalik uni bo‘limlar bo‘yicha jo‘natish mumkin.",
  "Первичная приемка демонстрационной партии": "Namoyish partiyasini dastlabki qabul qilish",
  "Первичная редакция заказа": "Buyurtmaning dastlabki versiyasi",
  "первичного факта.": "kuzatiladi.",
  "Первый участок": "Birinchi bo‘lim",
  "Перевозчик": "Tashuvchi",
  "Перевозчик: {shipment.carrier}": "Tashuvchi: {shipment.carrier}",
  "Перед запечатыванием подтверждаются изделие, ремень, головной убор, шеврон и упаковочный материал.": "Mahsulot, kamar, bosh kiyim, chevron va qadoqlash materiallari muhrlanishdan oldin tasdiqlanadi.",
  "Передавайте комплекты бригаде и регистрируйте принятие, выпуск и возврат по каждой операции маршрута.": "To‘plamlarni ekipajga topshiring va har bir marshrut operatsiyasi uchun qabul qilish, chiqarish va qaytishni qayd etish.",
  "Передаем…": "Biz uzatamiz ...",
  "Передайте раскроенный комплект на первую операцию технологического маршрута.": "Kesish to‘plamini texnologik marshrutning birinchi operatsiyasiga o‘tkazing.",
  "Передать": "Transfer",
  "Передать в пошив": "Tikuvchilikka o‘tish",
  "Передать комплект · {0}": "Transfer to‘plami · {0}",
  "Передать комплект на ОТК": "To‘plamni sifat nazorati bo‘limiga topshiring",
  "Передать на пошив можно только активный раскроенный комплект.": "Tikish uchun faqat faol kesilgan to‘plam yuborilishi mumkin.",
  "Перейти к журналу дефектов": "Nosozliklar jurnaliga o‘ting",
  "Перемещение": "Harakatlanuvchi",
  "Перемещение +": "+ harakatlantiring",
  "Перемещение −": "Ko‘chirish -",
  "Перемещение: приход": "Ko‘chirish: kelish",
  "Перемещение: расход": "Harakat: iste'mol",
  "Перепоставка по строке {po_line.line_number}: заказано {po_line.quantity}.": "{po_line.line_number} liniyasida qayta yetkazib berish: buyurtma qilingan {po_line.quantity}.",
  "Перерасчет разрешен только для черновой или рассчитанной ведомости.": "Qayta hisoblash faqat qoralama yoki hisoblangan qaydnomalar uchun ruxsat etiladi.",
  "Перерыв, мин": "Tanaffus, min",
  "Перерыв, минут": "Tanaffus, daqiqalar",
  "Пересекающиеся утвержденные периоды блокируются сервером.": "Bir-biriga o‘xshash tasdiqlangan muddatlar server tomonidan bloklanadi.",
  "Пересчитать": "Qayta hisoblang",
  "Переход {order.status} → {target} запрещен настройкой workflow.sales_order.": "{order.status} → {target} ga o‘tish workflow.sales_order sozlamasi bilan taqiqlangan.",
  "Период пересекается с действующей расценкой операции.": "Davr joriy tranzaksiya narxiga to‘g‘ri keladi.",
  "Периоды действия": "Yaroqlilik muddatlari",
  "Персонал": "Xodimlar",
  "Пилотная поставка для второго этапа": "Ikkinchi bosqich uchun uchuvchi yetkazib berish",
  "Пилотный заказ этапа 1": "1-bosqich pilot buyurtmasi",
  "план": "reja",
  "План": "Reja",
  "План {0}": "{0} rejasi",
  "План выпуска": "Chiqarish rejasi",
  "План заданий раскроя превышает план партии.": "Kesish vazifasi rejasi partiya rejasidan oshib ketadi.",
  "План комплектов кроя": "Kesilgan to‘plamlarning tartibi",
  "План производства превышает количество строки заказа.": "Ishlab chiqarish rejasi buyurtma qatori miqdoridan oshib ketadi.",
  "План-факт и отклонение": "Rejaning haqiqiy va farqi",
  "План-факт производства": "Ishlab chiqarish rejasi",
  "План-факт, отклонения, качество, обеспеченность и начисления в одной управленческой сводке.": "Bir boshqaruv xulosasida reja-fakt, og‘ishlar, sifat, ta'minlash va hisob-kitoblar.",
  "План, мин": "Reja, min",
  "План, минут": "Reja, daqiqalar",
  "План, шт": "Reja, dona.",
  "Планируйте выпуск только по подтвержденной редакции заказа и действующему маршруту.": "Rejani faqat tasdiqlangan buyurtmani qayta ishlash va to‘g‘ri yo‘nalish bo‘yicha rejalashtirish.",
  "Плановое количество": "Rejalashtirilgan miqdor",
  "Плановое обновление уведомлений": "Rejalashtirilgan bildirishnoma yangilanishi",
  "Плановый контрольный пересчет": "Rejalashtirilgan nazoratni qayta hisoblash",
  "Плановый коридор": "Yo‘lakni rejalashtirish",
  "Платформа / область доступа": "Platforma/kirish maydoni",
  "Площадка": "Joy",
  "Площадки": "Joylar",
  "Площадки, отделы, рабочие центры и склады, используемые в RBAC.": "RBACda foydalaniladigan saytlar, bo‘limlar, ish markazlari va omborlar.",
  "По 10 штук в коробе": "Bir qutiga 10 dona",
  "по дате факта": "fakt sanasi bo‘yicha",
  "по единицам измерения ledger": "daftar birliklari bo‘yicha",
  "По операциям": "Operatsiyalar bo‘yicha",
  "По системе": "Tizim bo‘yicha",
  "По согласованию закрывается только частично исполненный подтвержденный заказ.": "Kelishuvga ko‘ra, faqat qisman to‘ldirilgan tasdiqlangan buyurtma yopiladi.",
  "По строке заказа": "Buyurtma liniyasi bo‘yicha",
  "По строке заявки {request_line.line_number} уже заказано {ordered_elsewhere}.": "{request_line.line_number} buyurtma liniyasi allaqachon {ordered_elsewhere} buyurtma qilgan.",
  "По текущей редакции заказа нет дефицита к закупке.": "Buyurtmaning joriy versiyasiga ko‘ra, sotib olish uchun hech qanday kamchilik yo‘q.",
  "По этой строке текущей редакции уже создан производственный заказ.": "Joriy nashrning ushbu qatori uchun ishlab chiqarish buyurtmasi allaqachon yaratilgan.",
  "Повтор": "Takrorlang",
  "Повтор интеграции: {failure.operation}": "Integratsiya takrori: {failure.operation}",
  "Повтор уже выполняется.": "Takrorlash allaqachon davom etmoqda.",
  "Повтор: {job.display_name}": "Takrorlash: {job.display_name}",
  "Повторить": "Qayta urinish",
  "Повторить можно только задание со статусом «Ошибка».": "Faqat \"Xato\" holatiga ega bo‘lgan vazifani takrorlash mumkin.",
  "повторная": "takrorlanadi",
  "Повторная отправка защищена уникальным ключом; факт нельзя изменить после записи.": "Qayta yuborish noyob kalit bilan himoyalangan; fakt qayd etilgandan keyin o‘zgartirilishi mumkin emas.",
  "Повторная приемка после доработки": "Qayta ko‘rib chiqilgandan keyin qayta qabul qilish",
  "Повторная проверка доступна только после завершенной доработки этого комплекта.": "Qayta tekshirish faqat ushbu to‘plam tugagandan so‘ng mumkin.",
  "Повторно проверена": "Qayta tekshirildi",
  "Повторный ОТК": "Takroriy sifat nazorati bo‘limi",
  "под подтвержденные заказы": "tasdiqlangan buyurtmalar uchun",
  "Подкладка": "Astar",
  "Подкладочная ткань хаки": "Xaki astarli mato",
  "Подразделение": "Bo‘lim",
  "Подразделение относится к другой организации.": "Bo‘lim boshqa tashkilotga tegishli.",
  "Подразделения": "Bo‘limlar",
  "Подтвердить": "Tasdiqlang",
  "Подтвержден": "Tasdiqlangan",
  "Подтвержденный заказ": "Tasdiqlangan buyurtma",
  "Позиции": "Lavozimlar",
  "Позиции заказа": "Buyurtma buyumlari",
  "Позиции и размерная матрица": "Pozitsiyalar va o‘lchovli matritsa",
  "Позиции:": "Lavozimlar:",
  "Позиций": "Pozitsiyalar",
  "позиций дефицита": "defitsit pozitsiyalari",
  "Позиция заказа": "Buyurtma elementi",
  "Поиск": "Qidiruv",
  "Поиск по заказу, клиенту или модели": "Buyurtma, mijoz yoki model bo‘yicha qidirish",
  "Показать пароль": "Parolni ko‘rsatish",
  "Полная копия": "To‘liq nusxa",
  "Полная расценка": "To‘liq narx",
  "Полнота": "To‘liqlik",
  "Полный отчет": "To‘liq hisobot",
  "Получаем актуальные данные системы.": "Biz joriy tizim ma'lumotlarini olamiz.",
  "Получатель": "Qabul qiluvchi",
  "Получатель относится к другой организации.": "Qabul qiluvchi boshqa tashkilotga tegishli.",
  "Получатель, тип события, важность и ограничение выборки задаются отдельно.": "Qabul qiluvchi, hodisa turi, ahamiyati va namuna olish chegarasi alohida ko‘rsatilgan.",
  "Получатель: {shipment.order.client.name}": "Qabul qiluvchi: {shipment.order.client.name}",
  "Получен": "Qabul qilingan",
  "Получение": "Kvitansiya",
  "Получено": "Qabul qilingan",
  "Пользователи": "Foydalanuvchilar",
  "Пользователи должны относиться к одной организации.": "Foydalanuvchilar bir xil tashkilotga tegishli bo‘lishi kerak.",
  "Пользователи и роли": "Foydalanuvchilar va rollar",
  "Пользователи относятся к другой организации.": "Foydalanuvchilar boshqa tashkilotga tegishli.",
  "Пользователь": "Foydalanuvchi",
  "Пользователь недоступен.": "Foydalanuvchi mavjud emas.",
  "Пользователь, действие или объект": "Foydalanuvchi, harakat yoki ob'ekt",
  "попыток": "urinishlar",
  "Порядок": "Buyurtma",
  "После активации маршрут и его операции становятся неизменяемыми.": "Faollashtirilgandan so‘ng, marshrut va uning operatsiyalari o‘zgarmas bo‘ladi.",
  "После планирования производственный заказ не редактируется.": "Rejalashtirilgandan so‘ng, ishlab chiqarish tartibi tahrirlanmaydi.",
  "После проведения короб станет доступен для резерва и отгрузки.": "Tugatgandan so‘ng, quti zahira va jo‘natish uchun mavjud bo‘ladi.",
  "После создания соберите только принятые производственные факты периода.": "Yaratilgandan so‘ng, faqat davrning qabul qilingan ishlab chiqarish faktlarini to‘plang.",
  "Последняя ошибка": "Oxirgi xato",
  "Последовательность операций должна начинаться с 1 и не иметь пропусков.": "Amaliyotlar ketma-ketligi 1 dan boshlanishi kerak va bo‘shliqlar bo‘lmasligi kerak.",
  "Поставить на паузу": "Pauza",
  "Поставка → партия → ячейка": "Yetkazib berish → partiya → katak",
  "Поставка летней форменной одежды": "Yozgi kiyimlarni yetkazib berish",
  "Поставка партиями по согласованному графику.": "Kelishilgan jadvalga muvofiq partiyalarda yetkazib berish.",
  "Поставка по согласованной заявке": "Kelishilgan so‘rov bo‘yicha yetkazib berish",
  "Поставщик": "Yetkazib beruvchi",
  "Поставщик / документ": "Yetkazib beruvchi/hujjat",
  "Поставщик не совпадает с заказом.": "Yetkazib beruvchi buyurtmaga mos kelmaydi.",
  "Поставщик: {(lot.supplier.name if lot.supplier else '—')}": "Yetkazib beruvchi: {(lot.supplier.name if lot.supplier else '—')}",
  "Поставщик: {order.supplier.name}<br/>Срок поставки: {order.expected_date:%d.%m.%Y}<br/>Валюта: {order.currency}": "Yetkazib beruvchi: {order.supplier.name}<br/>Etkazib berish muddati: {order.expected_date:%d.%m.%Y}<br/>Valyuta: {order.currency}",
  "Поставщики": "Yetkazib beruvchilar",
  "Поступление: {lot.received_at:%d.%m.%Y}": "Kvitansiya: {lot.received_at:%d.%m.%Y}",
  "Потери": "Yo‘qotishlar",
  "Потребность": "Kerak",
  "Потребность еще не рассчитана": "Talab hali hisoblab chiqilmagan",
  "Потребность и дефицит": "Ehtiyoj va tanqislik",
  "Потребность относится к другому заказу.": "Talab boshqa buyurtmaga tegishli.",
  "Потребность рассчитывается только для подтвержденной редакции заказа.": "Talab faqat buyurtmaning tasdiqlangan versiyasi uchun hisoblanadi.",
  "Пошив": "Tikuv",
  "Пошив завершен": "Tikuv tugallandi",
  "Пошив и операции": "Tikuv va operatsiyalar",
  "Пояс и застежка": "Kamar va qisqich",
  "Правила уведомлений": "Xabar berish qoidalari",
  "Правило": "Qoida",
  "Правило маркировки": "Belgilash qoidasi",
  "Правило согласования": "Shartnoma qoidasi",
  "Правило упаковки": "Qadoqlash qoidasi",
  "Правило workflow должно содержать объекты transitions и required_fields.": "Ish oqimi qoidasi o‘tish va zarur_maydonlar obyektlarini o‘z ichiga olishi kerak.",
  "Предмет": "Element",
  "Предупреждение": "Ogohlantirish",
  "Предыдущая страница": "Oldingi sahifa",
  "Приемка": "Qabul qilish",
  "Приемка коробов": "Qutilarni qabul qilish",
  "Приемка материалов": "Materiallarni qabul qilish",
  "Приемки не удаляются. Используйте сторно.": "Qabullar o‘chirilmaydi. Qaytarilishdan foydalaning.",
  "прикреплено": "biriktirilgan",
  "применение": "ilova",
  "Применить": "Murojaat qiling",
  "Применить изменения; без флага выполняется dry-run": "O‘zgarishlarni qo‘llash; bayroqsiz quruq yugurish bajariladi",
  "Применить импорт может пользователь с правом эксплуатации.": "Import amal qilish huquqiga ega foydalanuvchi tomonidan qo‘llanilishi mumkin.",
  "Примечание": "Eslatma",
  "Принимаем": "Qabul qilamiz",
  "Принята на склад": "Omborga qabul qilingan",
  "Принята ОТК": "Sifat nazorati bo‘limi tomonidan qabul qilingan",
  "принято": "qabul qilingan",
  "Принято": "Qabul qilingan",
  "Принято + доработка + брак должны равняться проверенному количеству.": "Qabul qilingan + qayta ishlash + rad etilganlar tasdiqlangan miqdorga teng bo‘lishi kerak.",
  "Принято к оплате": "To‘lov uchun qabul qilingan",
  "Принято ОТК": "Sifat nazorati bo‘limi tomonidan qabul qilingan",
  "Принятые без замечаний проверки не создают строк в этом реестре.": "Sharhsiz qabul qilingan cheklar ushbu registrda qatorlar yaratmaydi.",
  "принятые ОТК отклонения": "sifat nazorati bo‘limi tomonidan qabul qilingan og‘ishlar",
  "Принятый ОТК комплект": "Sifat tasdiqlangan to‘plam",
  "Принять": "Qabul qiling",
  "Приоритет": "Ustuvorlik",
  "Приостановлен": "To‘xtatildi",
  "Присутствие, активные назначения и готовность сдельных начислений за выбранный период.": "Tanlangan davr uchun hisob-kitoblarning mavjudligi, faol topshiriqlari va tayyorligi.",
  "Присутствовал": "Hozirgi",
  "Присутствуют": "Hozirgi",
  "Присутствуют сегодня": "Bugun taqdim eting",
  "Приход": "Parish",
  "Приход (ISO дата/время)": "Yetib kelish (ISO sanasi/vaqti)",
  "Приход готовой продукции": "Tayyor mahsulotlarning kelishi",
  "Приходные документы": "Kiruvchi hujjatlar",
  "Приходы готовой продукции не удаляются. Используйте сторно.": "Tayyor mahsulot kvitansiyalari o‘chirilmaydi. Qaytarilishdan foydalaning.",
  "Приходы не удаляются. Используйте сторно.": "Kelganlar o‘chirilmaydi. Qaytarilishdan foydalaning.",
  "Причина": "Sabab",
  "Причина и длительность попадут в производственный журнал.": "Sababi va muddati ishlab chiqarish jurnaliga kiritiladi.",
  "Причина изменения": "O‘zgartirish sababi",
  "Причина корректировки": "Sozlash sababi",
  "Причина отмены": "Bekor qilish sababi",
  "Причина списания": "Hisobdan chiqarish sababi",
  "Причины дефектов": "Kamchiliklarning sabablari",
  "Причины остановок": "To‘xtash sabablari",
  "Проведен": "O‘tkazilgan",
  "Проведена": "O‘tkazilgan",
  "Проведение необратимо изменит остаток; исправление выполняется сторно.": "Amalga oshirish qolgan qismini qaytarib bo‘lmaydigan darajada o‘zgartiradi; tuzatish teskari.",
  "Проведенная упаковка не редактируется.": "Joylashtirilgan qadoqni tahrirlash mumkin emas.",
  "Проведенную инвентаризацию изменять нельзя.": "Tugallangan inventarni o‘zgartirib bo‘lmaydi.",
  "Проведенную приемку изменять нельзя.": "Qabul qilingandan so‘ng, qabul qilishni o‘zgartirib bo‘lmaydi.",
  "Проведенный складской документ изменять нельзя.": "Joylashtirilgan ombor hujjatini o‘zgartirish mumkin emas.",
  "проверено": "tasdiqlangan",
  "Проверено": "Tasdiqlangan",
  "Проверить": "Tekshirish",
  "Проверка": "Tekshirish",
  "Проверка восстановления": "Qayta tiklash tekshiruvi",
  "Проверка партии фиксирует неизменяемый результат: принято, доработка и окончательный брак.": "Partiyani tekshirish o‘zgarmas natijani qayd etadi: qabul qilingan, qayta ko‘rib chiqilgan va yakuniy nuqson.",
  "Проверки и циклы приемки": "Tekshiruvlar va qabul qilish davrlari",
  "Проверки ОТК не удаляются. Используйте отмену.": "Sifat nazorati tekshiruvlari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Проверок пока нет": "Hali tekshiruvlar yo‘q",
  "Проверьте адрес или вернитесь в рабочую область.": "Manzilni tekshiring yoki ish joyiga qayting.",
  "Проверьте заполнение полей.": "Maydonlar to‘ldirilganligini tekshiring.",
  "Проверьте размерную матрицу и утвердите документ.": "O‘lchov matritsasini tekshiring va hujjatni tasdiqlang.",
  "Проверяем защищенную сессию": "Himoyalangan sessiya tekshirilmoqda",
  "Проверяем эксплуатационный контур": "Ishlash sxemasini tekshirish",
  "Проверяемое количество превышает доступное ({available}).": "Tekshirilayotgan miqdor mavjud miqdordan oshib ketdi ({available}).",
  "Проверяет или применяет контролируемый CSV-импорт начальных справочников и остатков.": "CSV boshlang‘ich kataloglari va qoldiqlarining nazorat qilinadigan importini tekshiradi yoki qo‘llaydi.",
  "Проверяется": "Tekshirildi",
  "Провести": "Amalga oshirish",
  "Провести можно только непустой черновик прихода.": "Siz faqat bo‘sh bo‘lmagan qoralama chekni joylashtirishingiz mumkin.",
  "Провести можно только черновик инвентаризации.": "Siz faqat qoralama inventarizatsiya qilishingiz mumkin.",
  "Провести можно только черновик приемки.": "Siz faqat qoralamani qabul qilishingiz mumkin.",
  "Провести можно только черновик.": "Faqat qoralama to‘ldirilishi mumkin.",
  "Проводим…": "Biz amalga oshiramiz ...",
  "Продажи / производственный портфель": "Savdo / ishlab chiqarish portfeli",
  "Продолжить": "Davom eting",
  "Продолжить работу": "Ishni davom ettiring",
  "Производитель": "Ishlab chiqaruvchi",
  "Производственная партия": "Ishlab chiqarish partiyasi",
  "Производственная партия относится к другой организации.": "Ishlab chiqarish partiyasi boshqa tashkilotga tegishli.",
  "Производственные заказы": "Ishlab chiqarish buyurtmalari",
  "Производственные заказы не удаляются. Используйте отмену.": "Ishlab chiqarish buyurtmalari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Производственные партии не удаляются. Используйте отмену.": "Ishlab chiqarish partiyalari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Производственный журнал не удаляется.": "Ishlab chiqarish jurnali o‘chirilmaydi.",
  "Производственный журнал является append-only.": "Ishlab chiqarish jurnali faqat qo‘shish uchun mo‘ljallangan.",
  "Производственный заказ": "Ishlab chiqarish tartibi",
  "Производственный заказ создается только по текущей подтвержденной редакции.": "Ishlab chiqarish buyurtmasi faqat tasdiqlangan tahrirga muvofiq tuziladi.",
  "Производственный поток работает без зафиксированных остановок.": "Ishlab chiqarish oqimi qayd etilgan to‘xtashlarsiz ishlaydi.",
  "Производственный факт уже включен в другую расчетную ведомость.": "Ishlab chiqarish fakti allaqachon boshqa ish haqi varaqasiga kiritilgan.",
  "Производственных заказов пока нет": "Hozircha ishlab chiqarish buyurtmalari mavjud emas",
  "Производство": "Ishlab chiqarish",
  "Производство / план выпуска": "Ishlab chiqarish / chiqarish rejasi",
  "Производство / план-факт": "Ishlab chiqarish / reja-haqiqiy",
  "Производство / управление потоком": "Ishlab chiqarish / oqim nazorati",
  "Производство по рабочим центрам": "Ish markazlari tomonidan ishlab chiqarish",
  "Прослеживаемость WIP": "Kuzatilish WIP",
  "Просрочен срок заказа": "Buyurtma muddati tugagan",
  "Просроченные заказы": "Kechiktirilgan buyurtmalar",
  "Просрочено": "Muddati o‘tgan",
  "Просрочено партий": "Muddati o‘tgan to‘plamlar",
  "Просрочка": "Muddati o‘tgan",
  "Просрочка заказа": "Kechiktirilgan buyurtma",
  "Просрочка, дней": "Muddati o‘tgan, kunlar",
  "Простоев не зарегистрировано": "Hech qanday uzilishlar qayd etilmagan",
  "Простои": "Ishdan chiqish vaqti",
  "Простой, мин": "To‘xtash vaqti, min",
  "Прочитать все": "Hammasini o‘qing",
  "Пуговица форменная 22 мм": "Yagona tugma 22 mm",
  "Пуговицы": "Tugmalar",
  "Пульс периода": "Puls davri",
  "пустые обязательные поля: {', '.join(sorted(empty))}": "bo‘sh majburiy maydonlar: {', '.join(sorted(empty))}",
  "Работает": "Ishlar",
  "Рабочее обсуждение": "Ish muhokamasi",
  "Рабочие центры": "Ish markazlari",
  "Рабочий центр": "Ish markazi",
  "Рабочий центр относится к другой организации.": "Ish markazi boshqa tashkilotga tegishli.",
  "Разбейте производственный заказ минимум на одну партию.": "Ishlab chiqarish tartibini kamida bitta partiyaga ajrating.",
  "Раздел недоступен": "Bo‘lim mavjud emas",
  "Размер": "Hajmi",
  "Размер / цвет": "Hajmi / rangi",
  "Размер комплекта не входит в сетку варианта заказа.": "Belgilangan o‘lcham buyurtma opsiyalari tarmog‘iga kiritilmagan.",
  "Размер не входит в сетку выбранного варианта.": "Hajmi tanlangan variantning panjarasiga kiritilmagan.",
  "Размер не найден.": "Hajmi topilmadi.",
  "Размер партии": "To‘plam hajmi",
  "Размер партии не входит в сетку варианта.": "Partiya hajmi optsionlar tarmog‘iga kiritilmagan.",
  "Размер файла превышает 10 МБ.": "Fayl hajmi 10 MB dan katta.",
  "Размер CSV превышает {settings.IMPORT_MAX_BYTES // 1024 // 1024} МБ.": "CSV {settings.IMPORT_MAX_BYTES // 1024 // 1024} MB dan kattaroq.",
  "Размерная сетка": "O‘lcham jadvali",
  "Размерные сетки": "O‘lcham jadvallari",
  "Размерных значений": "O‘lcham qiymatlari",
  "Размеры": "O‘lchamlari",
  "Размеры 44–58, рост 3–6": "O‘lchamlari 44–58, balandligi 3–6",
  "Разница": "Farq",
  "Разрешена отгрузка": "Yuk tashishga ruxsat berilgan",
  "Разрешения": "Ruxsatlar",
  "Разрешения (JSON-массив)": "Ruxsatlar (JSON massivi)",
  "Раскроено": "Ochilgan",
  "Раскрой": "Bichish",
  "Раскрой {task.code}": "{task.code}-ni kesib oling",
  "Раскрой и настилы": "Kesish va yotqizish",
  "Распределение результатов ОТК": "Sifat nazorati natijalarini taqsimlash",
  "Рассчитана": "Hisoblangan",
  "рассчитанных ведомостей": "hisoblangan qaydnomalar",
  "Рассчитать": "Hisoblash",
  "расход": "iste'mol",
  "Расход": "Iste'mol",
  "Расхождение": "Divergentsiya",
  "Расценка": "Tarif",
  "Расценки и выработка": "Narxlar va ishlab chiqarish",
  "Расценки и начисления": "Tariflar va hisob-kitoblar",
  "Расценки операций": "Tranzaksiya narxlari",
  "Расчет начислений": "To‘lovlarni hisoblash",
  "Расчет появится после утверждения заказа.": "Hisoblash buyurtma tasdiqlangandan keyin paydo bo‘ladi.",
  "Расчетные ведомости не удаляются. Используйте отмену.": "Ish haqi varaqalari o‘chirilmaydi. Bekor qilishdan foydalaning.",
  "Расчетные периоды": "Hisob-kitob davrlari",
  "Расшифровка ведомости": "Qaydnomani tushuntirish",
  "Рахимов": "Rahimov",
  "Рахмонов": "Rahmonov",
  "Регистрирует результат backup или restore drill для метрик и эксплуатационного журнала.": "Ko‘rsatkichlar va operatsion jurnal uchun zaxira nusxasi yoki tiklash ma'lumoti natijalarini qayd qiladi.",
  "ред.": "tahr.",
  "Редактирование · {0}": "{0} tahrirlash",
  "Редактировать": "Tahrirlash",
  "Редакции": "Tahrirlar",
  "Редакции заказа": "Buyurtma tahrirlari",
  "Редакция": "Tahrir",
  "Редакция заказа": "Buyurtma tahriri",
  "Редакция открыта": "Tahrir ochiq",
  "Реестр заказов": "Buyurtmalar reestri",
  "Реестр коробов": "Qutilar reestri",
  "РЕЕСТР КОРОБОВ": "QUTILAR RO‘YXATI",
  "Реестр BOM": "BOM ro‘yxatga olish kitobi",
  "Резерв": "Zaxira",
  "Резерв заказа": "Buyurtma zaxirasi",
  "Резерв и частичные отгрузки": "Zaxira va qisman jo‘natish",
  "Резерв превышает неисполненное обязательство заказа ({obligation - committed}).": "Zaxira to‘lanmagan buyurtma majburiyatidan ({obligation - committed}) oshib ketgan.",
  "Резерв создается только по подтвержденному заказу этой организации.": "Zaxira faqat ushbu tashkilotning tasdiqlangan buyrug‘i asosida tuziladi.",
  "Резерв уже использован или снят.": "Zaxira allaqachon ishlatilgan yoki olib qo‘yilgan.",
  "Резервируется только непустой черновик отгрузки.": "Faqat bo‘sh bo‘lmagan qoralama jo‘natmalar zahiraga olinadi.",
  "Резервные коды (каждый действует один раз):": "Zaxira kodlari (har biri bir marta amal qiladi):",
  "Резервы": "Zaxiralar",
  "Результат": "Natija",
  "Результат ОТК · {0}": "Sifat nazorati natijasi {0}",
  "Реквизиты, адреса и ответственные лица заказчиков.": "Mijozlarning tafsilotlari, manzillari va mas'ul shaxslari.",
  "ремень": "kamar",
  "Ремень": "Kamar",
  "Роли": "Rollar",
  "Роли (можно несколько)": "Rollar (bir nechta mumkin)",
  "Роли и разрешения": "Rollar va ruxsatlar",
  "Роль": "Rol",
  "Роль относится к другой организации.": "Rol boshqa tashkilotga tegishli.",
  "Рост": "O‘sish",
  "Рулон": "Roll",
  "Рулон: {lot.roll_number} · оттенок {lot.shade or '—'}": "Rulo: {lot.roll_number} soya {lot.shade or '—'}",
  "Русский": "Ruscha",
  "Рустам": "Rustam",
  "с": "bilan",
  "Саида": "Saida",
  "Саидова": "Saidova",
  "Сайт": "Veb-sayt",
  "Самарканд": "Samarqand",
  "Самарканд Транс Сервис": "Samarqand Trans Servis",
  "Самарканд, ул. Буюк Ипак Йули, 41": "Samarqand, st. Buyuk Ipak Yo‘li, 41 yosh",
  "Самаркандская область": "Samarqand viloyati",
  "Сафаров": "Safarov",
  "Сборка основных деталей": "Asosiy qismlarni yig‘ish",
  "Сборка шаговых швов": "Cho‘tkaning tikuvlarini yig‘ish",
  "Сверка и выпуск · {0}": "{0}ni yarashtirish va chiqarish",
  "Свернуть меню": "Menyuni yig‘ish",
  "Сверяем готовую продукцию": "Biz tayyor mahsulotlarni tekshiramiz",
  "Сверяем WIP и производственные события": "Biz WIP va ishlab chiqarish voqealarini solishtiramiz",
  "Свободно к отгрузке": "Yuk tashish uchun mavjud",
  "Свяжите заказ, операцию, сотрудника, принятую выработку и действующую расценку в одной проверяемой системе.": "Buyurtma, operatsiya, ishchi, qabul qilingan mahsulot va joriy narxni bitta tekshiriladigan tizimda bog‘lang.",
  "Сезон": "Mavsum",
  "Сезоны": "Fasllar",
  "Сервер вернул некорректный ответ.": "Server noto‘g‘ri javob qaytardi.",
  "Сертификаты": "Sertifikatlar",
  "Сессия была завершена.": "Sessiya yakunlandi.",
  "Сессия завершена": "Sessiya tugadi",
  "Сессия истекла или была завершена.": "Seans muddati tugagan yoki tugatilgan.",
  "Сессия истекла.": "Seans muddati tugadi.",
  "Сигналы создаются идемпотентно: повторная проверка не дублирует одно и то же бизнес-событие.": "Signallar idempotent tarzda ishlab chiqariladi: takroriy tekshiruvlar bir xil biznes hodisasini takrorlamaydi.",
  "Система": "Tizim",
  "Система вернет короб на склад и создаст встречное движение ledger.": "Tizim qutini omborga qaytaradi va qarshi harakat kitobini yaratadi.",
  "Система проведет возврат и заблокирует выпуск сверх плана.": "Tizim to‘lovni qaytarib beradi va rejadan tashqari chiqarishni bloklaydi.",
  "Система фиксирует учетный остаток на начало пересчета и проводит разницу отдельным корректировочным движением.": "Tizim qayta hisoblash boshida buxgalteriya balansini qayd qiladi va farqni alohida tuzatish harakatida joylashtiradi.",
  "Системную роль нельзя деактивировать.": "Tizim rolini o‘chirib bo‘lmaydi.",
  "Системные задания": "Tizim vazifalari",
  "Системные настройки": "Tizim sozlamalari",
  "Системный": "Tizim",
  "Системных заданий пока нет": "Hali tizim vazifalari yo‘q",
  "Склад": "Ombor",
  "Склад / входящий поток": "Ombor / kiruvchi oqim",
  "Склад / готовая продукция": "Ombor / tayyor mahsulotlar",
  "Склад / достоверный остаток": "Ombor / ishonchli balans",
  "Склад / исходящий и внутренний поток": "Ombor / chiqish va kiruvchi oqim",
  "Склад / контроль достоверности": "Ombor/haqiqiylikni nazorat qilish",
  "Склад / ячейка": "Ombor / katak",
  "Склад готовой продукции": "Tayyor mahsulotlar ombori",
  "Склад ГП": "GP ombori",
  "Склад или ячейка относится к другой организации.": "Ombor yoki katak boshqa tashkilotga tegishli.",
  "Склад относится к другой организации.": "Ombor boshqa tashkilotga tegishli.",
  "Склад сырья": "Xom ashyo ombori",
  "Склад, зона, стеллаж, ячейка": "Ombor, zona, raf, katak",
  "Складская ячейка": "Ombor katagi",
  "Складские документы не удаляются. Используйте сторно.": "Ombor hujjatlari o‘chirilmaydi. Qaytarilishdan foydalaning.",
  "Складские операции": "Ombor operatsiyalari",
  "Складской ledger является append-only.": "Ombor kitobi faqat qo‘shimchalar uchun mo‘ljallangan.",
  "Склады": "Omborlar",
  "Скрыть пароль": "Parolni yashirish",
  "Следующая страница": "Keyingi sahifa",
  "Слоев": "Qatlamlar",
  "слоя": "qatlam",
  "Случаи": "Ishlar",
  "см. README": "README ga qarang",
  "Смена": "O‘zgartirish",
  "Смены": "Shiftlar",
  "Снабжение / поставщики": "Ta'minot / etkazib beruvchilar",
  "Сначала выполните dry-run, затем примените тот же проверенный набор.": "Avval quriting, keyin bir xil tasdiqlangan to‘plamni qo‘llang.",
  "Сначала запланируйте производственный заказ.": "Birinchidan, ishlab chiqarish tartibini rejalashtiring.",
  "Сначала зарезервируйте готовую продукцию для отгрузки.": "Birinchidan, jo‘natish uchun tayyor mahsulotlarni zaxiralang.",
  "Сначала создайте BOM для варианта изделия.": "Avval mahsulot varianti uchun BOM yarating.",
  "Сначала утвердите текущую редакцию.": "Birinchidan, joriy tahrirni tasdiqlang.",
  "Снят": "Oʻchirildi",
  "Снять": "O‘chirish",
  "Собираем ведомость выработки": "Ishlab chiqarish varag‘ini yig‘ish",
  "Собираем диспетчерскую очередь": "Jo‘natish navbatini yig‘ish",
  "Собираем ролевую управленческую сводку": "Rollarni boshqarish xulosasini yig‘ish",
  "Собираем управленческий отчет": "Boshqaruv hisobotini yig‘ish",
  "Событие": "Tadbir",
  "Событие аудита нельзя изменять.": "Audit hodisasini o‘zgartirish mumkin emas.",
  "Событие аудита нельзя удалять.": "Audit hodisasini o‘chirib bo‘lmaydi.",
  "событий ·": "voqealar ·",
  "Событий пока нет": "Hozircha hech qanday voqea yo‘q",
  "События производства": "Ishlab chiqarish voqealari",
  "Совпадений не найдено": "Hech qanday moslik topilmadi",
  "Согласована": "Kelishilgan",
  "Согласование": "Muvofiqlashtirish",
  "Согласование технологом до резерва или выпуска заявки на закупку": "Xarid qilish talabini zaxiralash yoki chiqarishdan oldin texnolog tomonidan muvofiqlashtirish",
  "Согласовать": "Rozi",
  "Создаем…": "Biz yaratamiz ...",
  "Создает идемпотентный демонстрационный набор данных этапов 1–6.": "1–6 bosqichlarning idempotent namunaviy maʼlumotlar toʻplamini yaratadi.",
  "Создайте задание по запланированной производственной партии.": "Rejalashtirilgan ishlab chiqarish partiyasi uchun ish joyini yarating.",
  "Создайте маршрут для активного варианта изделия.": "Faol mahsulot varianti uchun marshrut yarating.",
  "Создайте первую запись, чтобы начать работу.": "Boshlash uchun birinchi yozuvingizni yarating.",
  "Создайте первый заказ из подтвержденной строки клиента.": "Tasdiqlangan mijozlar qatoridan birinchi buyurtmani yarating.",
  "Создан": "Yaratilgan",
  "Создание заказа": "Buyurtma yarating",
  "Создание, размерные матрицы, редакции и согласование клиентских заказов.": "Mijozlarning buyurtmalarini yaratish, o‘lchovli matritsalar, qayta ishlash va muvofiqlashtirish.",
  "создано ·": "yaratilgan ·",
  "Создать": "Yaratish",
  "Создать заказ": "Buyurtma yarating",
  "Создать и провести": "Yaratish va joylashtirish",
  "Создать маршрут": "Marshrut yaratish",
  "Создать новую редакцию": "Yangi nashr yarating",
  "Создать правило": "Qoida yarating",
  "Создать приход": "Jamoat yarating",
  "Создать редакцию": "Nashr yarating",
  "Создать смену": "Shift yarating",
  "Создать черновик": "Qoralama yarating",
  "Сопроводительные документы": "Qo‘shimcha hujjatlar",
  "Сорт": "Turli xillik",
  "Сорт / класс": "Turli xil / sinf",
  "Состав": "Tarkibi",
  "Состояние": "Vaziyat",
  "Сотрудник": "Xodim",
  "Сотрудник или назначение относится к другой организации.": "Xodim yoki topshiriq boshqa tashkilotga tegishli.",
  "Сотрудник или смена относится к другой организации.": "Xodim yoki smena boshqa tashkilotga tegishli.",
  "Сотрудники": "Xodimlar",
  "Сотрудники и смены": "Xodimlar va smenalar",
  "Сотрудники, смены и табель": "Xodimlar, smenalar va vaqt jadvallari",
  "сотрудников с отметкой в табеле": "hisobot kartasida belgisi bo‘lgan xodimlar",
  "Сохраненные представления": "Saqlangan koʻrishlar",
  "Сохраненных видов пока нет": "Hozircha saqlangan turlar yo‘q",
  "Сохранить": "Saqlash",
  "Сохранить вид": "Ko‘rinishni saqlash",
  "Сохранить заказ": "Buyurtmani saqlang",
  "Сохранить представление": "Ko‘rinishni saqlash",
  "Сохранить черновик": "Qoralama saqlang",
  "Сохраняем…": "Saqlaylik...",
  "Специалист по кадрам и оплате": "HR va to‘lov bo‘yicha mutaxassis",
  "Специалист по отгрузке": "Yuk tashish bo‘yicha mutaxassis",
  "Спецификация": "Spetsifikatsiya",
  "Спецификация заказа {order.code}": "Buyurtma spetsifikatsiyasi {order.code}",
  "Спецификация зафиксирована": "Spetsifikatsiya aniqlandi",
  "Списание": "Hisobdan chiqarish",
  "Справочники": "Ma’lumotnomalar",
  "Срез потока": "Oqim kesilishi",
  "Срок": "Muddati",
  "Срок поставки, дней": "Yetkazib berish muddati, kunlar",
  "Срок, дн.": "Davomiyligi, kunlar",
  "Сроки заказов, дефицит, выпуск и готовность продукции к отгрузке.": "Buyurtma muddati, etishmovchilik, mahsulotlarni jo‘natish uchun chiqarish va tayyorligi.",
  "Сроки, валюта, условия и статус контрактов клиентов.": "Mijoz shartnomalarining shartlari, valyutasi, shartlari va holati.",
  "Срочный": "Shoshilinch",
  "Ссылка": "Havola",
  "Статус": "Status",
  "Стеллаж": "Rak",
  "столбец — факт · риска — план": "ustun - fakt xavfi - reja",
  "Сторнирован": "Teskari",
  "Сторнировать можно только проведенную приемку.": "Faqat tugallangan qabulni bekor qilish mumkin.",
  "Сторнировать можно только проведенный документ.": "Faqat e'lon qilingan hujjatni bekor qilish mumkin.",
  "Сторно": "Storno",
  "Сторно {document.code}": "Orqaga {document.code}",
  "Сторно {receipt.code}": "Orqaga {receipt.code}",
  "Сторно операции": "Operatsiyani teskari aylantirish",
  "Сторно отгрузки": "Yuk tashishning teskari holati",
  "Сторно прихода": "Jamoatning o‘zgarishi",
  "Сторно:": "Storno:",
  "строк": "chiziqlar",
  "Строка": "String",
  "Строка {0}": "{0} qatori",
  "Строка {error['line']}: {error['message']}": "{error['line']} qatori: {error['message']}",
  "Строка {line.line_number} относится к другой заявке.": "{line.line_number} qatori boshqa ilovaga ishora qiladi.",
  "Строка не относится к текущей редакции заказа.": "Chiziq buyurtmaning joriy nashriga taalluqli emas.",
  "Строка отгрузки не обеспечена активным резервом.": "Yuk tashish liniyasi faol zaxira bilan ta'minlanmagan.",
  "Строка относится к другой заявке.": "Chiziq boshqa ilovaga ishora qiladi.",
  "Строка относится к другому заказу поставщику.": "Chiziq yetkazib beruvchiga boshqa buyurtmani bildiradi.",
  "Строка приемки относится к другому заказу поставщику.": "Qabul qilish liniyasi yetkazib beruvchiga boshqa buyurtmani bildiradi.",
  "Строки": "Strings",
  "Строки завершенной проверки ОТК не изменяются.": "Tugallangan QC tekshiruvi satrlari o‘zgartirilmaydi.",
  "Строки начисления являются append-only.": "Hisoblash satrlari faqat qo‘shiladi.",
  "Строки ОТК не удаляются.": "QC liniyalari o‘chirilmaydi.",
  "Строки упаковки не удаляются.": "Qadoqlash chiziqlari o‘chirilmaydi.",
  "Строки утвержденного начисления не удаляются.": "Tasdiqlangan hisoblash chiziqlari o‘chirilmaydi.",
  "Сумма": "Miqdori",
  "Сумма ведомости": "Hisobot miqdori",
  "Сумма документа": "Hujjat summasi",
  "Сумма не вводится вручную: каждая строка проходит от принятого факта производства через действующую расценку к начислению.": "Miqdor qo‘lda kiritilmaydi: har bir satr qabul qilingan ishlab chiqarish faktidan joriy narxdan boshlab hisoblanishgacha o‘tadi.",
  "Сумма партий ({total}) должна равняться плану заказа ({production_order.planned_quantity}).": "To‘plamning umumiy miqdori ({total}) buyurtma rejasiga ({production_order.planned_quantity}) teng bo‘lishi kerak.",
  "Сумма партий должна равняться плану производственного заказа.": "Partiyalarning umumiy miqdori ishlab chiqarish buyurtmasi rejasiga teng bo‘lishi kerak.",
  "Сумма размерной матрицы ({total}) должна равняться количеству строки.": "O‘lcham matritsasining yig‘indisi ({total}) qator soniga teng bo‘lishi kerak.",
  "Сумма трех исходов должна точно совпадать с проверенным количеством.": "Uchta natijaning yig‘indisi tasdiqlangan miqdorga to‘liq mos kelishi kerak.",
  "Суперадминистратор": "Super administrator",
  "Сформировано": "Shakllangan",
  "Сформировать упаковку": "Shakl qadoqlash",
  "Сырье": "Xom ashyo",
  "Таб. №": "Tab. Yo‘q.",
  "Табель": "Hisobot kartasi",
  "Табельный номер": "Xodimlar soni",
  "Табельный номер, имя или должность": "Xodimning raqami, ismi yoki lavozimi",
  "Такое обновление уже было запущено в текущую минуту.": "Ayni paytda bunday yangilanish allaqachon boshlangan.",
  "Такой страницы нет": "Bunday sahifa yo‘q",
  "Текущая версия": "Joriy versiya",
  "Текущая редакция уже утверждена или отсутствует.": "Joriy nashr allaqachon tasdiqlangan yoki yo‘q.",
  "Текущий пароль указан неверно.": "Joriy parol noto‘g‘ri.",
  "Текущий пользователь": "Joriy foydalanuvchi",
  "Текущий участок": "Joriy sayt",
  "Текущий этап": "Hozirgi bosqich",
  "Текущую партию нельзя поставить на паузу.": "Joriy o‘yinni to‘xtatib bo‘lmaydi.",
  "Телефон": "Telefon",
  "Темно-синий": "Toʻq koʻk",
  "Темно-синяя": "Toʻq koʻk",
  "Темур": "Temur",
  "Технолог / конструктор": "Texnolog / dizayner",
  "Технологические маршруты": "Texnologik marshrutlar",
  "Технологический маршрут": "Texnologik yo‘nalish",
  "Технологический отдел": "Texnologiya bo‘limi",
  "Технология / последовательность операций": "Texnologiya/operatsiyalar ketma-ketligi",
  "Технология / рецептура изделия": "Texnologiya / mahsulot retsepti",
  "Тип": "Turi",
  "Тип данных": "Ma'lumotlar turi",
  "Тип материала": "Material turi",
  "Тип склада": "Ombor turi",
  "Тип упаковки": "Qadoqlash turi",
  "Тип: {package.get_package_type_display()}": "Turi: {package.get_package_type_display()}",
  "Ткани · основной стеллаж": "Matolarning asosiy rafi",
  "Ткань": "Mato",
  "Ткань / рулон": "Mato / rulo",
  "Ткань смесовая оливковая 240 г/м²": "Zaytun aralashmasi mato 240 g/m²",
  "Ткань смесовая оливковая 245 г/м² · аналог": "Zaytun aralashmasi 245 g/m² analogli mato",
  "ТОВАР": "MAHSULOT",
  "ТОВАРНО-ТРАНСПОРТНАЯ НАКЛАДНАЯ": "HISSA QO‘LLANISHI QO‘LLANISHI",
  "Только проверить (dry-run)": "Faqat tekshiring (quruq ishga tushirish)",
  "Точность": "Aniqlik",
  "Транзит": "Tranzit",
  "Требования клиента": "Mijoz talablari",
  "Требуется": "Majburiy",
  "Требуется согласование": "Tasdiqlash talab qilinadi",
  "Турсунова": "Tursunova",
  "У вас нет права на это действие.": "Siz buni qilishga haqqingiz yo‘q.",
  "Уведомления": "Bildirishnomalar",
  "Уволен": "Otilgan",
  "Удалить операцию": "Operatsiyani o‘chirish",
  "Удалить позицию": "Joyni o‘chirish",
  "Удалить строку": "Chiziqni o‘chirish",
  "Удалять можно только собственные представления.": "Siz faqat o‘z qarashlaringizni o‘chirishingiz mumkin.",
  "Узбекский": "O‘zbekcha",
  "Укажите документально согласованное основание недопоставки.": "Kamchilikning hujjatlashtirilgan asosini ko‘rsating.",
  "Укажите код и описание причины простоя.": "Kodni va ishlamay qolish sababini tavsifini ko‘rsating.",
  "Укажите количество минимум по одной позиции.": "Iltimos, kamida bitta mahsulot miqdorini ko‘rsating.",
  "Укажите корректный UUID ключ повторяемости.": "Yaroqli takrorlash kalitini UUID kiriting.",
  "Укажите основание согласованной недопоставки.": "Kelishilgan kamomadning asosini ko‘rsating.",
  "Укажите положительный факт принятия, завершения или возврата.": "Ijobiy qabul qilish, tugatish yoki qaytarishni ko‘rsating.",
  "Укажите причину изменения утвержденной спецификации.": "Tasdiqlangan spetsifikatsiyani o‘zgartirish sababini ko‘rsating.",
  "Укажите причину отмены.": "Iltimos, bekor qilish sababini ko‘rsating.",
  "Укажите причину сторно отгрузки.": "Yetkazib berishni bekor qilish sababini ko‘rsating.",
  "ул. Буюк Ипак Йули, 41": "st. Buyuk Ipak Yo‘li, 41 yosh",
  "Упакована": "Qadoqlangan",
  "Упакованный короб": "Qadoqlangan quti",
  "Упаковано": "Qadoqlangan",
  "Упаковать": "Paket",
  "Упаковать можно только непустой черновик упаковки.": "Faqat bo‘sh bo‘lmagan qoralama paketni qadoqlash mumkin.",
  "упаковка": "qadoqlash",
  "Упаковка": "Qadoqlash",
  "Упаковка {package.code} · партия {package.batch.code}": "Qadoqlash {package.code} · partiya {package.batch.code}",
  "Упаковка и QR": "Qadoqlash va QR",
  "Упаковка не найдена или недоступна.": "Paket topilmadi yoki mavjud emas.",
  "Упаковка относится к другой организации.": "Paket boshqa tashkilotga tegishli.",
  "Упаковка:": "Qadoqlash:",
  "Упаковки не удаляются. Используйте отмену.": "Paketlar olib tashlanmaydi. Bekor qilishdan foydalaning.",
  "Упаковок пока нет": "Hozircha paketlar yoʻq",
  "Упаковочный манифест": "Qadoqlash manifest",
  "Упаковщик / кладовщик ГП": "Paketchi/Do‘konchi GP",
  "Управление ведомственного снабжения": "Idoraviy ta'minot bo‘limi",
  "Условия": "Shartlar",
  "Условия должны быть JSON-объектом.": "Shartlar JSON ob'ekti bo‘lishi kerak.",
  "Условия и важные замечания": "Shartlar va muhim eslatmalar",
  "Условия оплаты": "To‘lov shartlari",
  "Условия JSON": "JSON shartlari",
  "Успешно": "Muvaffaqiyatli",
  "Устарел": "Eskirgan",
  "Устарела": "Eskirgan",
  "Устранена": "Yo‘q qilingan",
  "Устранить зафиксированные дефекты и вернуть на повторную приемку.": "Aniqlangan kamchiliklarni bartaraf etish va qayta qabul qilish uchun qaytarish.",
  "Утвердил": "Tasdiqlangan",
  "Утвердил: {0}": "Tasdiqlangan: {0}",
  "Утвердите заказ или запустите расчет по действующим версиям BOM.": "Buyurtmani tasdiqlang yoki BOM ning joriy versiyalaridan foydalanib hisoblashni boshlang.",
  "Утвердить": "Tasdiqlash",
  "Утвердить можно только непустой черновик заявки.": "Faqat bo‘sh bo‘lmagan qoralama arizani tasdiqlash mumkin.",
  "Утвердить можно только рассчитанную ведомость.": "Faqat hisoblangan qaydnoma tasdiqlanishi mumkin.",
  "Утвердить текущую редакцию? После этого спецификация будет заблокирована.": "Joriy nashrni tasdiqlaysizmi? Shundan so‘ng, spetsifikatsiya qulflanadi.",
  "Утверждена": "Tasdiqlangan",
  "утверждена {0}": "tasdiqlangan {0}",
  "Утвержденная расценка неизменяема. Создайте новый период.": "Tasdiqlangan narxni o‘zgartirish mumkin emas. Yangi davr yarating.",
  "Утвержденную расценку удалить нельзя.": "Tasdiqlangan taklifni oʻchirib boʻlmaydi.",
  "Утвержденную редакцию нельзя изменить. Создайте новую редакцию в карточке заказа.": "Tasdiqlangan nashrni o‘zgartirish mumkin emas. Buyurtma kartasida yangi nashr yarating.",
  "Утвержденную редакцию нельзя изменять. Создайте новую редакцию.": "Tasdiqlangan nashrni o‘zgartirish mumkin emas. Yangi nashr yarating.",
  "Утвержденный ввод начальных остатков": "Boshlang‘ich qoldiqlarning tasdiqlangan yozuvi",
  "Утюжка и отделка": "Dazmollash va pardozlash",
  "Уход (ISO дата/время)": "Xizmat (ISO sanasi/vaqti)",
  "Участок": "Syujet",
  "Участок / исполнитель": "Sayt / ijrochi",
  "Учет": "Buxgalteriya hisobi",
  "Учетная запись": "Hisob",
  "Учетная запись относится к другой организации.": "Hisob boshqa tashkilotga tegishli.",
  "Файл не найден: {source}": "Fayl topilmadi: {source}",
  "Файловое хранилище": "Fayl saqlash",
  "Файлы": "Fayllar",
  "Файлы еще не добавлены.": "Hali hech qanday fayl qo‘shilmagan.",
  "Факт": "Fakt",
  "Факт доработки · {0}": "Qayta ishlash fakti · {0}",
  "Факт доработки превышает назначенное количество.": "Qayta ishlash fakti belgilangan miqdordan oshib ketadi.",
  "Факт может регистрировать назначенный исполнитель или мастер.": "Fakt tayinlangan ijrochi yoki usta tomonidan ro‘yxatga olinishi mumkin.",
  "Факт настила · {0}": "{0} pol qoplamasi fakti",
  "Факт операции": "Operatsiya fakti",
  "Факт, мин": "Haqiqat, min",
  "Фактически": "Aslida",
  "Фактические значения не могут быть отрицательными.": "Haqiqiy qiymatlar salbiy bo‘lishi mumkin emas.",
  "Фактический выпуск превышает план партии.": "Haqiqiy ishlab chiqarish paket rejasidan oshib ketdi.",
  "Фактический выпуск превышает план производственного заказа.": "Haqiqiy mahsulot ishlab chiqarish buyurtmasi rejasidan oshib ketadi.",
  "Фактов по участкам пока нет": "Hududlar haqida hozircha faktlar yo‘q",
  "Факты доработки не удаляются.": "Tahrirlar o‘chirilmaydi.",
  "Факты доработки являются append-only.": "Tekshirish faktlari faqat ilova qilinadi.",
  "Факты производственных операций не удаляются.": "Ishlab chiqarish operatsiyalari faktlari o‘chirilmaydi.",
  "Факты производственных операций являются append-only.": "Ishlab chiqarish operatsiyalari faktlari faqat ilova qilinadi.",
  "Фамилия": "Familiya",
  "Фаррух": "Farrux",
  "Физически": "Jismoniy jihatdan",
  "Физический баланс сверяется с ledger; доступное количество никогда не включает чужой резерв.": "Jismoniy balans daftar bilan tekshiriladi; mavjud miqdor hech qachon boshqa birovning zaxirasini o‘z ichiga olmaydi.",
  "Физический остаток": "Jismoniy qoldiq",
  "Фиксируем…": "Keling, tuzatamiz...",
  "Фильтры периода и состав колонок будут доступны в один клик.": "Davr filtrlari va ustunlar tarkibi bir marta bosish orqali mavjud bo‘ladi.",
  "Финишная сборка": "Yakuniy yig‘ilish",
  "Финишная сборка и комплектность": "Yakuniy yig‘ish va to‘liqlik",
  "Фото": "Surat",
  "Фото дефекта {defect.defect_type.code}": "{defect.defect_type.code} nuqsoni fotosurati",
  "Фурнитура / прочее": "Aksessuarlar / boshqalar",
  "Характеристики": "Xususiyatlari",
  "Холмуродов": "Xolmurodov",
  "Цвет": "Rang",
  "Цвет или рабочий центр относится к другой организации.": "Rang yoki ish markazi boshqa tashkilotga tegishli.",
  "Цвета": "Ranglar",
  "Цена": "Narxi",
  "Цена за единицу": "Birlik narxi",
  "Центр событий": "Tadbirlar markazi",
  "Цех / комплект → готовый пошив": "Seminar / to‘plam → tayyor tikuv",
  "Цех / материал → комплект": "Seminar / material → to‘plam",
  "Цикл": "Velosiped",
  "цикл закрыт": "tsikl yopiq",
  "Часовой пояс": "Vaqt mintaqasi",
  "Частичная поставка фиксируется по партии или рулону и сразу создает движения складского ledger.": "Qisman yetkazib berish partiya yoki rulon orqali qayd etiladi va darhol ombor daftarining harakatlarini yaratadi.",
  "Частично": "Qisman",
  "Частично обеспечено": "Qisman qo‘llab-quvvatlangan",
  "Частично получен": "Qisman qabul qilingan",
  "Черновик": "Qoralama",
  "Что остановило партию": "Bayramni nima to‘xtatdi",
  "Шахноза": "Shahnoza",
  "Швея": "Tikuvchi",
  "шеврон": "chevron",
  "Шеврон": "Chevron",
  "Шевроны": "Chevronlar",
  "Ширина, см": "Kengligi, sm",
  "шт": "dona",
  "шт.": "dona",
  "шт. · доработка": "dona · qayta ishlash",
  "шт. ×": "dona ×",
  "Штука": "Parcha",
  "Эксплуатация": "Operatsiya",
  "Экспорт разрешен только для утвержденной ведомости.": "Eksportga faqat tasdiqlangan qaydnomalar uchun ruxsat beriladi.",
  "Экспорт реестра": "Registrni eksport qilish",
  "Экспорт PDF": "PDF eksport qiling",
  "Экспорт XLSX": "XLSX eksport qiling",
  "Экспортирована": "Eksport qilingan",
  "Эргашева": "Ergasheva",
  "этап 2": "bosqich 2",
  "этап 3": "bosqich 3",
  "этап 4": "bosqich 4",
  "Этап 4 / контроль качества": "4-bosqich / sifat nazorati",
  "Этап 5 · {0}": "5-bosqich {0}",
  "Этап 5 · кадровый контур": "5-bosqich · xodimlar konturi",
  "Этап 5 · сдельная оплата": "5-bosqich · parcha-parcha to‘lov",
  "Этап 5 · управленческая аналитика": "5-bosqich · boshqaruv tahlili",
  "Этап 5 · центр событий": "5-bosqich Tadbirlar markazi",
  "Этап 6 · промышленная эксплуатация": "6-bosqich · sanoat ekspluatatsiyasi",
  "Этап 6: промышленный ERP-контур с очередью заданий, наблюдаемостью, управляемой миграцией и восстановлением.": "6-bosqich: ish navbati, kuzatuvchanlik, boshqariladigan migratsiya va tiklanish bilan sanoat ERP sxemasi.",
  "Этикетка": "Yorliq",
  "Этикетка упаковки": "Qadoqlash yorlig‘i",
  "Этикетка QR": "QR yorlig‘i",
  "Это поле не может быть пустым.": "Bu maydon bo‘sh bo‘lishi mumkin emas.",
  "Это поле обязательно.": "Bu maydon majburiy.",
  "Этот тип файла не разрешен.": "Ushbu fayl turiga ruxsat berilmagan.",
  "Этот файл уже был успешно применен. Повторная загрузка заблокирована.": "Bu fayl allaqachon muvaffaqiyatli qo‘llanilgan. Qayta yuklash bloklandi.",
  "Эту заявку уже нельзя отменить.": "Bu so‘rovni endi bekor qilib bo‘lmaydi.",
  "Юлдашева": "Yo‘ldosheva",
  "Юридический": "Huquqiy",
  "Юридическое название": "Yuridik nom",
  "Юсупова": "Yusupova",
  "Язык": "Til",
  "Ячейка": "Katak",
  "Ячейка не принадлежит выбранному складу.": "Axlat qutisi tanlangan omborga tegishli emas.",
  "Ячейка приемки": "Qabul qilish kamerasi",
  "Append-only / расследование событий": "Faqat qo‘shish / hodisani tekshirish",
  "Append-only журнал": "Faqat qo‘shish jurnali",
  "BOM": "BOM",
  "BOM / резерв": "BOM / zaxira",
  "BOM зафиксирован": "BOM tuzatildi",
  "BOM и версии норм": "BOM va standart versiyalar",
  "BOM и нормы": "BOM va me’yorlar",
  "BOM относится к другой организации.": "BOM boshqa tashkilotga tegishli.",
  "category_code: {row['category_code']} не найден": "kategoriya_kodi: {row['category_code']} topilmadi",
  "CRM / договорная база": "CRM / shartnoma bazasi",
  "CRM / контрагенты": "CRM / kontragentlar",
  "CSRF-проверка не пройдена: {reason}": "CSRF tekshiruvi amalga oshmadi: {reason}",
  "CSV должен быть в кодировке UTF-8.": "CSV UTF-8 kodlashda boʻlishi kerak.",
  "CSV не содержит строк данных.": "CSV hech qanday ma'lumot qatorlarini o‘z ichiga olmaydi.",
  "CSV превышает допустимый размер.": "CSV ruxsat etilgan hajmdan oshib ketdi.",
  "CSV содержит больше {settings.IMPORT_MAX_ROWS} строк.": "CSV {settings.IMPORT_MAX_ROWS} dan ortiq qatorlarni o‘z ichiga oladi.",
  "CSV-файл": "CSV fayli",
  "CSRF-проверка не пройдена: Origin checking failed - {0} does not match any trusted origins.": "CSRF tekshiruvi o‘tmadi: {0} manbasi ishonchli manbalar ro‘yxatiga kiritilmagan.",
  "ERP / MES-light · этап 6": "ERP / MES-light 6-bosqich",
  "HEX (например #144829)": "HEX (masalan, #144829)",
  "is_fabric: используйте true/false": "is_fabric: true/false dan foydalaning",
  "Ledger готовой продукции является append-only.": "Tayyor mahsulot ledgeri o‘zgarmas yozuvlardan iborat.",
  "Ledger движений": "Harakatlar ledgeri",
  "LEYTENANT · маршрутный лист": "LEYTENANT · marshrut varaqasi",
  "LEYTENANT · ПАРТИЯ МАТЕРИАЛА": "LEYTENANT · MATERIAL PARTIYASI",
  "LEYTENANT · ЭТИКЕТКА УПАКОВКИ": "LEYTENANT · QADOQLASH YORLIG‘I",
  "LEYTENANT ERP · Этап 6 · 2026": "LEYTENANT ERP 6-bosqich 2026 yil",
  "limit должен быть от 1 до 500.": "chegarasi 1 dan 500 gacha bo‘lishi kerak.",
  "limit должен быть целым числом.": "chegara butun son bo‘lishi kerak.",
  "location_code: {row['location_code']} не найден": "joy_kodi: {row['location_code']} topilmadi",
  "lot_code уже относится к другому материалу": "lot_code allaqachon boshqa materialga ishora qiladi",
  "material_code: {row['material_code']} не найден": "material_kodi: {row['material_code']} topilmadi",
  "QR содержит только безопасный токен": "QR faqat xavfsiz tokenni o‘z ichiga oladi",
  "QR содержит только непрозрачный идентификатор упаковки.": "QR faqat noaniq paket identifikatoridan iborat.",
  "RBAC · HttpOnly cookies · append-only факты": "RBAC · HttpOnly cookie · o‘zgarmas faktlar",
  "Recovery run зарегистрирован: {run.id}": "Qayta tiklash ishga tushirildi: {run.id}",
  "Refresh-токен отсутствует.": "Yangilash belgisi yo‘q.",
  "RTO факт": "RTO fakt",
  "unit_code: {row['unit_code']} не найден": "unit_code: {row['unit_code']} topilmadi",
  "UTF-8, до 5 МБ / 10 000 строк": "UTF-8, 5 MB / 10 000 qatorgacha",
  "WAL-архив": "WAL-arxiv",
  "warehouse_code: {row['warehouse_code']} не найден": "ombor_kodi: {row['warehouse_code']} topilmadi",
  "WIP": "WIP",
  "WIP и простои": "WIP va to‘xtashlar",
  "WIP производства": "WIP ishlab chiqarish",
  "WIP, отклонения и простои": "WIP, og‘ishlar va uzilishlar",
  "Workflow содержит неизвестный статус заказа.": "Ish jarayoni noma'lum buyurtma holatini o‘z ichiga oladi.",
  "Workflow содержит поле вне разрешенного набора.": "Ish jarayoni ruxsat etilgan to‘plamdan tashqarida joylashgan maydonni o‘z ichiga oladi.",
  "API p95": "API p95",
  "Append-only": "Faqat qo‘shish mumkin",
  "Backup / restore": "Zaxira nusxalash / tiklash",
  "dry-run": "sinov ishga tushirilishi",
  "E-mail": "E-pochta",
  "ERP / MES-light": "ERP / MES-yengil",
  "PDF": "PDF",
  "PDF + QR": "PDF + QR",
  "Restore drill": "Tiklash sinovi",
  "RPO": "RPO",
  "RTO": "RTO",
  "STAGE 06": "6-BOSQICH",
  "XLSX": "XLSX",
  "append-only": "faqat qo‘shish mumkin",
  "Версия": "Versiya",
  "Техническая карточка": "Texnik karta",
  "Головные уборы": "Bosh kiyimlar",
  "Кепка": "Kepka",
  "Фуражка": "Furajka",
  "Берет": "Beret",
  "Обхват головы": "Bosh aylanasi",
  "см": "sm",
  "Задний фасон": "Orqa fasoni",
  "Козырек": "Kepka soyaboni",
  "Кокарда": "Kokarda",
  "В этой редакции нет позиций с головными уборами.": "Ushbu tahrirda bosh kiyim pozitsiyalari mavjud emas.",
  "Оплата клиента": "Mijoz to‘lovi",
  "Аванс и остаток": "Avans va qoldiq",
  "Стоимость заказа": "Buyurtma qiymati",
  "Оплачено": "To‘langan",
  "Наличные": "Naqd pul",
  "Карта": "Karta",
  "Перевод": "O‘tkazma",
  "Платежи еще не зарегистрированы.": "To‘lovlar hali qayd etilmagan.",
  "Сумма платежа, UZS": "To‘lov summasi, UZS",
  "Способ оплаты": "To‘lov usuli",
  "Чек / комментарий": "Chek / izoh",
  "Номер чека или ссылка": "Chek raqami yoki havola",
  "Принять оплату": "To‘lovni qabul qilish",
  "Приём и выдача": "Qabul qilish va topshirish",
  "Зафиксируйте момент приёма заказа и согласованное время выдачи.": "Buyurtma qabul qilingan vaqt va kelishilgan topshirish vaqtini belgilang.",
  "Дата и время приёма": "Qabul qilish sanasi va vaqti",
  "Время выдачи": "Topshirish vaqti",
  "Параметры головного убора": "Bosh kiyim parametrlari",
  "Включите карточку только для позиции с кепкой, фуражкой, беретом или другим головным убором.": "Kartani faqat kepka, furajka, beret yoki boshqa bosh kiyim pozitsiyasi uchun yoqing.",
  "Это головной убор": "Bu bosh kiyim",
  "Позиция": "Pozitsiya",
  "Вид головного убора": "Bosh kiyim turi",
  "Выберите ткань": "Matoni tanlang",
  "Обхват головы, см": "Bosh aylanasi, sm",
  "Фасон задней части": "Orqa qismining fasoni",
  "Например, регулируемая застежка": "Masalan, sozlanadigan mahkamlagich",
  "Длина козырька, мм": "Kozyrek uzunligi, mm",
  "Тип, номер или требование": "Turi, raqami yoki talab",
  "Индивидуальные пожелания": "Individual istaklar",
  "Первичный платёж": "Birinchi to‘lov",
  "Аванс фиксируется отдельной неизменяемой операцией в журнале платежей.": "Zalog to‘lovlar jurnalida alohida o‘zgarmas operatsiya sifatida qayd etiladi.",
  "Аванс, UZS": "Zalog, UZS",
  "Номер чека / ссылка": "Chek raqami / havola",
  "Остаток после аванса": "Zalogdan keyingi qoldiq",
  "Обычная": "Oddiy",
  "Фасонная": "Fasonli",
  "Специальная": "Maxsus",
  "Фасон модели": "Model fasoni",
  "По размерной матрице": "O‘lchamlar jadvali bo‘yicha",
  "Эмблема спереди": "Old qismidagi emblema",
  "Звезда / знак звания": "Yulduz / unvon belgisi",
  "Боковые и другие знаки": "Yon va boshqa belgilar",
  "Цвет ниток": "Tikuv ipining rangi",
  "Образец головного убора": "Bosh kiyim namunasi",
  "Открыть образец": "Namunani ochish",
  "Образец / фото": "Namuna / rasm",
  "PNG, JPG или WebP, до 10 МБ. Образец сохраняется с редакцией.": "PNG, JPG yoki WebP, 10 MB gacha. Namuna tahrir bilan saqlanadi.",
  "Загружаем образец…": "Namuna yuklanmoqda…",
  "Убрать образец": "Namunani olib tashlash",
  "Пошив и знаки отличия": "Tikuv va unvon belgilari",
  "Ход выполнения": "Bajarilish jarayoni",
  "Производство по заказу": "Buyurtma bo‘yicha ishlab chiqarish",
  "Этапы заказа": "Buyurtma bosqichlari",
  "Отгружено по заказу": "Buyurtma bo‘yicha jo‘natildi",
  "Предыдущая редакция": "Oldingi tahrir",
  "Производственные партии ещё не созданы. После утверждения подготовьте материалы и маршрут.": "Ishlab chiqarish partiyalari hali yaratilmagan. Tasdiqlangandan so‘ng materiallar va texnologik yo‘nalishni tayyorlang.",
  "Номер воинской части": "Harbiy qism raqami",
  "Представитель заказчика": "Buyurtmachi vakili",
  "Телефон заказчика": "Buyurtmachining telefoni",
  "Не оплачено": "To‘lanmagan",
  "Частично оплачено": "Qisman to‘langan",
  "Оплачено полностью": "To‘liq to‘langan",
  "Для индивидуального пошива. В партии используйте размерную матрицу.": "Yakka buyurtma uchun. Partiyada o‘lchamlar jadvalidan foydalaning.",
  "Все размеры из заказа": "Buyurtmadagi barcha o‘lchamlar",
  "Каждый размер из заказа станет отдельной партией с исходным количеством.": "Buyurtmadagi har bir o‘lcham dastlabki miqdori bilan alohida partiyaga aylanadi.",
  "Для головного убора выберите ткань.": "Bosh kiyim uchun matoni tanlang.",
  "Образец относится к другой организации.": "Namuna boshqa tashkilotga tegishli.",
  "Загрузите изображение как образец головного убора.": "Rasmni bosh kiyim namunasi sifatida yuklang.",
  "Укажите положительное количество, без отрицательных размеров.": "Musbat miqdorni kiriting, o‘lchamlar miqdori manfiy bo‘lmasin.",
  "Размер не должен повторяться в одной позиции.": "Bir pozitsiyada o‘lcham takrorlanmasligi kerak.",
  "Количество головных уборов должно быть целым.": "Bosh kiyimlar miqdori butun son bo‘lishi kerak.",
  "Номера позиций не должны повторяться.": "Pozitsiya raqamlari takrorlanmasligi kerak.",
  "Образец должен быть изображением PNG, JPG или WebP.": "Namuna PNG, JPG yoki WebP rasmi bo‘lishi kerak.",
  "Образец неизменяем. Загрузите новый файл в черновике редакции.": "Namuna o‘zgartirilmaydi. Tahrir qoralamasida yangi fayl yuklang.",
  "Образец используется в спецификации и не может быть удален.": "Namuna spetsifikatsiyada ishlatilgan va uni o‘chirib bo‘lmaydi.",
  "Для головных уборов создайте партии по размерной матрице.": "Bosh kiyimlar uchun o‘lchamlar jadvali bo‘yicha partiyalar yarating.",
  "Укажите размер из заказа и целое положительное количество.": "Buyurtmadagi o‘lchamni va musbat butun miqdorni kiriting.",
  "Размер или цвет партии не соответствует заказу.": "Partiya o‘lchami yoki rangi buyurtmaga mos kelmaydi.",
  "Для этого варианта заполните параметры головного убора.": "Bu variant uchun bosh kiyim parametrlarini to‘ldiring.",
  "Ткань головного убора отсутствует в действующей BOM. Технолог должен согласовать норму для выбранной ткани.": "Bosh kiyim matosi amaldagi BOMda yo‘q. Texnolog tanlangan mato uchun me’yorni tasdiqlashi kerak.",
  "Для обычного входа используйте 6 цифр из приложения-аутентификатора. Резервный код действует только один раз.": "Odatdagi kirish uchun autentifikator ilovasidagi 6 xonali kodni kiriting. Har bir zaxira kodidan faqat bir marta foydalanish mumkin.",
  "Нет доступа к кодам? Обратитесь к администратору для восстановления входа.": "Kodlarga kirish imkoningiz yo‘qmi? Kirishni tiklash uchun administratorga murojaat qiling.",
  "Заказы кепок": "Kepka buyurtmalari",
  "Рабочее место кепок": "Kepka buyurtmalari bilan ishlash",
  "Заказы · образцы · оплата": "Buyurtmalar · namunalar · to‘lov",
  "Оператор заказов кепок": "Kepka buyurtmalari operatori",
  "Новый заказ кепок": "Yangi kepka buyurtmasi",
  "Оформляйте кепки, прикладывайте образец, отмечайте оплату и следите за выполнением.": "Kepka buyurtmasini kiriting, namuna qo‘shing, to‘lovni yozing va bajarilishini kuzating.",
  "После подготовки производства здесь появятся партии кепок.": "Ishlab chiqarish tayyorlangach, kepka partiyalari shu yerda ko‘rinadi.",
  "В этом рабочем месте доступны только кепки.": "Bu ish joyida faqat kepkalar bilan ishlash mumkin.",
  "Выберите действующий вариант кепки.": "Kepkaning faol variantini tanlang.",
  "Образец недоступен в рабочем месте кепок.": "Bu namuna kepka ish joyida ochilmaydi.",
  "Заказ недоступен в рабочем месте кепок.": "Bu buyurtma kepka ish joyida ochilmaydi.",
  "В этом рабочем месте менеджером нового заказа является текущий пользователь.": "Yangi buyurtmaning mas’uli tizimga kirgan foydalanuvchi bo‘ladi.",
  "В этом рабочем месте загружаются только образцы кепок.": "Bu ish joyida faqat kepka namunalari yuklanadi.",
  "⌘ K": "⌘ K",
  "Введите минимум 2 символа": "Kamida 2 ta belgi kiriting",
  "Результаты поиска": "Qidiruv natijalari",
  "Стрелки — выбор, Enter — открыть": "Strelkalar — tanlash, Enter — ochish",
  "Esc — закрыть": "Esc — yopish",
  "Разделы страницы": "Sahifa bo‘limlari",
  "Рабочее пространство": "Ish maydoni",
  "Материалы и склад": "Materiallar va ombor",
  "Команда и отчётность": "Jamoa va hisobotlar",
  "Администрирование": "Boshqaruv",
  "Управление производством": "Ishlab chiqarishni boshqarish",
  "Развернуть меню": "Menyuni kengaytirish",
  "Перейти к содержимому": "Asosiy mazmunga o‘tish",
  "Разделы рабочего пространства": "Ish maydoni bo‘limlari",
  "От заказа до готового изделия": "Buyurtmadan tayyor mahsulotgacha",
  "Заказы, материалы, производство и оплата — в одном рабочем пространстве.": "Buyurtmalar, materiallar, ishlab chiqarish va to‘lov — yagona ish maydonida.",
  "Клиент, размеры и образец": "Mijoz, o‘lchamlar va namuna",
  "Раскрой, пошив и контроль качества": "Bichish, tikish va sifat nazorati",
  "Упаковка, отгрузка и оплата": "Qadoqlash, jo‘natish va to‘lov",
  "Доступ к разделам определяется вашей ролью": "Bo‘limlarga kirish rolingizga qarab belgilanadi",
  "LEYTENANT ERP · 2026": "LEYTENANT ERP · 2026",
  "План и фактический выпуск, шт.": "Reja va amaldagi ishlab chiqarish, dona",
  "Представление данных": "Maʼlumotlar ko‘rinishi",
  "Данные": "Maʼlumotlar",
  "Навигационный путь": "Navigatsiya yo‘li",
  "Ещё": "Yana",
  "Меню пользователя": "Foydalanuvchi menyusi",
  "Карточка заказа": "Buyurtma kartasi",
  "График отчёта": "Hisobot diagrammasi",
  "На графике — первые 8 строк. Полные данные — в таблице ниже.": "Diagrammada dastlabki 8 qator ko‘rsatilgan. To‘liq maʼlumotlar quyidagi jadvalda.",
  "Диаграмма": "Diagramma",
  "Код участка": "Uchastka kodi",
  "Нет данных": "Ma’lumot yo‘q",
  "Долг": "Qarz",
  "Кредитный лимит": "Kredit limiti",
  "Выручка": "Savdo tushumi",
  "Себестоимость": "Tannarx",
  "Валовая прибыль": "Yalpi foyda",
  "Товар": "Mahsulot",
  "В пути": "Yo‘lda",
  "К закупке": "Xarid uchun",
  "Подготовить закупку": "Xaridni tayyorlash",
  "По товарам": "Mahsulotlar bo‘yicha",
  "По категориям": "Toifalar bo‘yicha",
  "По клиентам": "Mijozlar bo‘yicha",
  "По менеджерам": "Menejerlar bo‘yicha",
  "По дням": "Kunlar bo‘yicha",
  "Получено за период": "Davrda olingan to‘lovlar",
  "Долг сейчас": "Joriy qarzdorlik",
  "Расходы за период": "Davr xarajatlari",
  "Операционная прибыль": "Operatsion foyda",
  "Продажи за период": "Davrdagi savdo",
  "Стоимость склада сейчас": "Omborning joriy qiymati",
  "С даты": "Boshlanish sanasi",
  "По дату": "Tugash sanasi",
  "Сегодня": "Bugun",
  "Этот месяц": "Joriy oy",
  "Выручка и прибыль учитывают проведённые отгрузки за выбранный период. Долги и остатки показаны на текущий момент.": "Tushum va foyda tanlangan davrdagi o‘tkazilgan jo‘natmalar bo‘yicha hisoblanadi. Qarzlar va qoldiqlar joriy holatda ko‘rsatilgan.",
  "Грузы в пути": "Yo‘ldagi yuklar",
  "Новые заказы": "Yangi buyurtmalar",
  "Новые клиенты": "Yangi mijozlar",
  "SKU на складе": "Ombordagi SKU",
  "Требуют пополнения": "Zaxirani to‘ldirish kerak",
  "Рекомендация учитывает свободный остаток и подтверждённые закупки в пути. Заказ поставщику создаётся после вашего подтверждения.": "Tavsiya erkin qoldiq va yo‘ldagi tasdiqlangan xaridlarni hisobga oladi. Yetkazib beruvchiga buyurtma siz tasdiqlagandan so‘ng yaratiladi.",
  "Клиенты с задолженностью": "Qarzdor mijozlar",
  "Долги и лимиты": "Qarzlar va limitlar",
  "История оплат": "To‘lovlar tarixi",
  "Оплата регистрируется в карточке продажи и сразу уменьшает остаток по заказу.": "To‘lov savdo kartasida qayd etiladi va buyurtma bo‘yicha qolgan to‘lovni darhol kamaytiradi.",
  "Выручка и валовая прибыль": "Savdo tushumi va yalpi foyda",
  "На графике — до 10 строк. Полные данные находятся в таблице.": "Grafikda 10 tagacha qator ko‘rsatilgan. To‘liq ma’lumotlar jadvalda.",
  "Без продаж за период: капитал на складе": "Davrda sotilmagan: ombordagi kapital",
  "Стоимость": "Qiymat",
  "Клиенты и повторные покупки": "Mijozlar va takroriy xaridlar",
  "Повторные покупки": "Takroriy xaridlar",
  "Последняя покупка": "Oxirgi xarid",
  "Операционные расходы": "Operatsion xarajatlar",
  "Аренда, связь и другие расходы бизнеса. Доставку закупки указывайте в себестоимости импорта, чтобы не учитывать её дважды.": "Ijara, aloqa va boshqa biznes xarajatlari. Yetkazib berish xarajatini ikki marta hisoblamaslik uchun import tannarxida ko‘rsating.",
  "Добавить расход": "Xarajat qo‘shish",
  "Статья расходов": "Xarajat turi",
  "Операционный расход": "Operatsion xarajat",
  "Сумма, UZS": "Summa, UZS",
  "Остаток оплаты": "To‘lov qoldig‘i",
  "Чаще покупает": "Ko‘p xarid qiladigan mahsulotlar",
  "Цена продажи": "Sotuv narxi",
  "Страна": "Mamlakat",
  "Контакт": "Aloqa uchun shaxs",
  "В архиве": "Arxivda",
  "Название товара": "Mahsulot nomi",
  "Единица измерения": "O‘lchov birligi",
  "Размер / длина": "O‘lcham / uzunlik",
  "Основной поставщик": "Asosiy yetkazib beruvchi",
  "Цена продажи, UZS": "Sotuv narxi, UZS",
  "Оптимальный запас": "Optimal zaxira",
  "Китай": "Xitoy",
  "Условия оплаты и поставки": "To‘lov va yetkazib berish shartlari",
  "Кредитный лимит, UZS": "Kredit limiti, UZS",
  "Нулевой лимит — только полная предоплата. Лимит учитывает неоплаченные подтверждённые заказы.": "Nol limit — faqat to‘liq oldindan to‘lov. Limit to‘lanmagan tasdiqlangan buyurtmalarni hisobga oladi.",
  "Поиск по названию или коду": "Nomi yoki kodi bo‘yicha qidirish",
  "Добавить категорию": "Toifa qo‘shish",
  "Новый товар": "Yangi mahsulot",
  "Карточка товара": "Mahsulot kartasi",
  "Карточка клиента": "Mijoz kartasi",
  "Карточка поставщика": "Yetkazib beruvchi kartasi",
  "Закупка фурнитуры": "Furnitura xaridi",
  "Продажа фурнитуры": "Furnitura savdosi",
  "Ожидаемая дата поставки": "Kutilayotgan yetkazib berish sanasi",
  "Срок оплаты": "To‘lov muddati",
  "Валюта закупки": "Xarid valyutasi",
  "Курс: UZS за единицу валюты": "Kurs: bir valyuta birligi uchun UZS",
  "Укажите согласованный курс этой закупки. Курс сохраняется в документе.": "Ushbu xarid uchun kelishilgan kursni kiriting. Kurs hujjatda saqlanadi.",
  "Выберите товар": "Mahsulotni tanlang",
  "Добавить товар": "Mahsulot qo‘shish",
  "Сумма товаров": "Mahsulotlar summasi",
  "Доставку и таможенные расходы добавьте в расчёт себестоимости до первой приёмки.": "Birinchi qabuldan oldin yetkazib berish va bojxona xarajatlarini tannarx hisobiga qo‘shing.",
  "Принять товары на склад": "Mahsulotlarni omborga qabul qilish",
  "Отгрузить товары": "Mahsulotlarni jo‘natish",
  "Введите фактически полученные количества. При первой приёмке себестоимость закупки фиксируется.": "Amalda olingan miqdorlarni kiriting. Birinchi qabulda xarid tannarxi qayd etiladi.",
  "Укажите фактическую отгрузку. Нулевое количество оставляет товар в резерве заказа.": "Amaldagi jo‘natmani ko‘rsating. Nol miqdor mahsulotni buyurtma zaxirasida qoldiradi.",
  "Основание / номер документа": "Asos / hujjat raqami",
  "Провести приёмку": "Qabulni o‘tkazish",
  "Провести отгрузку": "Jo‘natmani o‘tkazish",
  "Транспорт по Китаю": "Xitoy ichki transporti",
  "Международная доставка": "Xalqaro yetkazib berish",
  "Таможня": "Bojxona",
  "Прочие расходы": "Boshqa xarajatlar",
  "Расходы на импорт": "Import xarajatlari",
  "Распределение расходов": "Xarajatlarni taqsimlash",
  "По стоимости товаров": "Mahsulotlar qiymati bo‘yicha",
  "По количеству, при одинаковых единицах": "Bir xil o‘lchov birligida miqdor bo‘yicha",
  "Вид расхода": "Xarajat turi",
  "Удалить расход": "Xarajatni olib tashlash",
  "Дополнительные расходы": "Qo‘shimcha xarajatlar",
  "Сохранить расчёт": "Hisobni saqlash",
  "Срок поставки": "Yetkazib berish muddati",
  "Сумма заказа": "Buyurtma summasi",
  "Номер или контрагент": "Raqam yoki kontragent",
  "Новая закупка": "Yangi xarid",
  "Новая продажа": "Yangi savdo",
  "Этапы импорта": "Import bosqichlari",
  "Полная себестоимость": "To‘liq tannarx",
  "Товары": "Mahsulotlar",
  "Всего": "Jami",
  "Накладная PDF": "Yuk xati PDF",
  "Новый этап": "Yangi bosqich",
  "Принять товары": "Mahsulotlarni qabul qilish",
  "Отменить закупку? Товары не поступят на склад.": "Xarid bekor qilinsinmi? Mahsulotlar omborga kelmaydi.",
  "Отменить закупку": "Xaridni bekor qilish",
  "Подтверждение проверит кредитный лимит и зарезервирует товары на складе.": "Tasdiqlash kredit limitini tekshiradi va ombordagi mahsulotlarni zaxiraga qo‘yadi.",
  "Подтвердить продажу": "Savdoni tasdiqlash",
  "Отменить продажу и освободить резерв?": "Savdo bekor qilinib, zaxira bo‘shatilsinmi?",
  "Отменить продажу": "Savdoni bekor qilish",
  "Счёт PDF": "To‘lov hisobi PDF",
  "Подтверждение действия": "Amalni tasdiqlash",
  "Оплата по заказу": "Buyurtma uchun to‘lov",
  "Себестоимость единицы": "Birlik tannarxi",
  "Партии": "Partiyalar",
  "Движения": "Harakatlar",
  "Внести начальный остаток": "Boshlang‘ich qoldiqni kiritish",
  "Закупленные товары принимайте в закупке. Начальный остаток используется для товаров, которые уже были на складе до начала учёта.": "Xarid qilingan mahsulotlarni xarid hujjatida qabul qiling. Boshlang‘ich qoldiq hisob boshlanishidan oldin omborda bo‘lgan mahsulotlar uchun ishlatiladi.",
  "Начальный остаток": "Boshlang‘ich qoldiq",
  "Себестоимость единицы, UZS": "Birlik tannarxi, UZS",
  "кг": "kg",
  "уп.": "qadoq",
  "Заказан": "Buyurtma berilgan",
  "Склад Китая": "Xitoy ombori",
  "Прибыл": "Yetib kelgan",
  "Принят": "Qabul qilingan",
  "Отменён": "Bekor qilingan",
  "Подтверждён": "Tasdiqlangan",
  "Отгружен": "Jo‘natilgan",
  "Приёмка": "Qabul",
  "Обзор фурнитуры": "Furnitura sharhi",
  "Склад фурнитуры": "Furnitura ombori",
  "Закупки из Китая": "Xitoydan xaridlar",
  "Продажи фурнитуры": "Furnitura savdosi",
  "Оплаты и долги": "To‘lovlar va qarzlar",
  "Прибыль и расходы": "Foyda va xarajatlar",
  "Отчёты фурнитуры": "Furnitura hisobotlari",
  "Торговля фурнитурой": "Furnitura savdosi",
  "Заказы производства": "Ishlab chiqarish buyurtmalari",
  "Закупки · склад · продажи": "Xaridlar · ombor · savdo",
  "Товары, поставки и расчёты с клиентами в одном рабочем месте.": "Mahsulotlar, yetkazib berishlar va mijozlar bilan hisob-kitoblar bitta ish joyida.",
  "SKU": "SKU",
  "UZS /": "UZS /",
  "Выберите корректный период до 10 лет.": "10 yilgacha bo‘lgan to‘g‘ri davrni tanlang.",
  "Выберите отгрузку этого заказа.": "Ushbu buyurtmaning jo‘natmasini tanlang.",
  "Выберите способ распределения расходов.": "Xarajatlarni taqsimlash usulini tanlang.",
  "Выберите строки этого документа без повторов.": "Ushbu hujjat satrlarini takrorsiz tanlang.",
  "Для отгрузки нужен подтверждённый заказ.": "Jo‘natish uchun tasdiqlangan buyurtma kerak.",
  "Для штучных товаров задайте целые пороги запаса.": "Donali tovarlar zaxira chegaralarini butun son bilan kiriting.",
  "Добавьте товары без повторов SKU.": "SKU takrorlanmagan tovarlarni qo‘shing.",
  "Добавьте товары.": "Tovarlarni qo‘shing.",
  "Документ изменился. Обновите страницу и повторите правку.": "Hujjat o‘zgargan. Sahifani yangilab, tahrirni takrorlang.",
  "Единицу товара с документами менять нельзя. Создайте новый SKU.": "Hujjatlarda ishlatilgan tovar birligini o‘zgartirib bo‘lmaydi. Yangi SKU yarating.",
  "Изменять можно только черновик продажи.": "Faqat sotuv qoralamasini tahrirlash mumkin.",
  "Клиент архивирован.": "Mijoz arxivlangan.",
  "Клиента оплаченного заказа менять нельзя.": "To‘lov qilingan buyurtmaning mijozini almashtirib bo‘lmaydi.",
  "Ключ повтора уже использован для другого документа.": "Takrorlash kaliti boshqa hujjat uchun ishlatilgan.",
  "Ключ повтора уже использован с другими данными.": "Takrorlash kaliti boshqa ma’lumotlar bilan ishlatilgan.",
  "Количество должно быть положительным; штучные товары продаются целыми единицами.": "Miqdor musbat bo‘lishi kerak; donali tovarlar butun birliklarda sotiladi.",
  "Количество превышает непроведённый остаток строки.": "Miqdor satrning hali o‘tkazilmagan qoldig‘idan oshadi.",
  "Курс UZS должен быть равен 1.": "UZS kursi 1 ga teng bo‘lishi kerak.",
  "Курс должен быть положительным; для UZS — 1.": "Kurs musbat bo‘lishi kerak; UZS uchun — 1.",
  "Лимит не может быть отрицательным.": "Limit manfiy bo‘lishi mumkin emas.",
  "Недостаточно доступного остатка: {sku}.": "Mavjud qoldiq yetarli emas: {sku}.",
  "Недостаточно принятых партий на дату отгрузки.": "Jo‘natish sanasiga qabul qilingan partiyalar yetarli emas.",
  "Нельзя распределить расходы на нулевую стоимость. Выберите распределение по количеству.": "Nol qiymatga xarajatlarni taqsimlab bo‘lmaydi. Miqdor bo‘yicha taqsimlashni tanlang.",
  "Нужен активный товар и неотрицательная цена.": "Faol tovar va manfiy bo‘lmagan narx kerak.",
  "Объект недоступен в этом рабочем месте.": "Obyekt ushbu ish joyida mavjud emas.",
  "Оплата превышает остаток или заказ отменён.": "To‘lov qoldiqdan oshadi yoki buyurtma bekor qilingan.",
  "Остаток товара превышает допустимую точность учёта.": "Tovar qoldig‘i hisobning ruxsat etilgan aniqligidan oshadi.",
  "Отмена доступна до оплаты и отгрузки.": "To‘lov va jo‘natishdan oldin bekor qilish mumkin.",
  "Переход на этот этап недоступен.": "Ushbu bosqichga o‘tish mumkin emas.",
  "По количеству": "Miqdor bo‘yicha",
  "По стоимости": "Qiymat bo‘yicha",
  "Подтвердить можно только черновик.": "Faqat qoralamani tasdiqlash mumkin.",
  "Поставщик архивирован.": "Yetkazib beruvchi arxivlangan.",
  "Превышен кредитный лимит клиента. Зарегистрируйте предоплату или измените лимит в карточке клиента.": "Mijozning kredit limiti oshib ketdi. Oldindan to‘lovni kiriting yoki mijoz kartasidagi limitni o‘zgartiring.",
  "Приёмка доступна после прибытия груза.": "Yuk kelganidan keyin qabul qilish mumkin.",
  "Проведённая запись не удаляется.": "O‘tkazilgan yozuv o‘chirilmaydi.",
  "Проведённая запись неизменяема.": "O‘tkazilgan yozuvni o‘zgartirib bo‘lmaydi.",
  "Рабочее место фурнитуры недоступно этому аккаунту.": "Ushbu hisob uchun furnitura ish joyi ochilmagan.",
  "Распределение по количеству допустимо только для одной единицы измерения.": "Miqdor bo‘yicha faqat bir xil o‘lchov birligidagi tovarlar taqsimlanadi.",
  "Расход неотрицателен, курс положителен.": "Xarajat manfiy bo‘lmasligi, kurs esa musbat bo‘lishi kerak.",
  "Себестоимость единицы превышает допустимую точность учёта.": "Birlik tannarxi hisobning ruxsat etilgan aniqligidan oshadi.",
  "Себестоимость зафиксирована при первой приёмке.": "Tannarx birinchi qabulda qayd etilgan.",
  "Состав закупки меняется только в черновике.": "Xarid tarkibini faqat qoralamada o‘zgartirish mumkin.",
  "Стоимость заказа не может быть ниже внесённой оплаты.": "Buyurtma qiymati kiritilgan to‘lovdan kam bo‘lishi mumkin emas.",
  "Сумма документа превышает допустимую точность учёта.": "Hujjat summasi hisobning ruxsat etilgan aniqligidan oshadi.",
  "Сумма должна быть положительной.": "Summa musbat bo‘lishi kerak.",
  "Такая запись уже существует или значения нарушают ограничения документа.": "Bunday yozuv mavjud yoki qiymatlar hujjat cheklovlariga mos emas.",
  "Такой SKU уже существует.": "Bunday SKU allaqachon mavjud.",
  "Товар архивирован.": "Tovar arxivlangan.",
  "Цены и запасы неотрицательны; оптимальный запас не меньше минимального.": "Narxlar va zaxiralar manfiy bo‘lmasligi kerak; optimal zaxira minimaldan kam bo‘lmasin.",
  "Последние 7 дней": "Oxirgi 7 kun"
}
